import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, timeout } from 'rxjs/operators'; // 2019-10-23 -- see if we can add timeout to calls
import { environment } from '../../../environments/environment';

// ref: https://ionicframework.com/docs/native/http/
// ref: https://www.joshmorony.com/dealing-with-cors-cross-origin-resource-sharing-in-ionic-applications/
import { HTTP } from '@ionic-native/http/ngx';

// third party libraries here
// https://forum.ionicframework.com/t/how-to-include-moment-js-in-ionic4/145819
import * as moment from 'moment'; 

//import { Storage } from '@ionic/storage';  // CONSOLIDATE THIS INTO global.ts
import { CommonService } from '../common/common.service';
import { GlobalService } from '../global/global.service';
import { GeolocationWrapperService } from '../geolocation/geolocation.service'; 

import { ApiReturn } from '../api/apireturn';
import { ApiResponse } from '../api/apireturn'; // dummy ApiResponse when API fails to respond
import { RuntimeService } from '../runtime/runtime.service';
import { GeoPosition } from '../geolocation/geoposition';
import { VirtualHeader } from '@ionic/angular';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private consoleLog:boolean = true;

  // PROD - PRODUCTION CLOUD - MS AZURE
  //private ApiServiceLoginContext:string = "PRODUCTION-SSL-0";
  //private ApiServiceEnvironment:string = "PROD-SSL-0";
  //private ApiServiceDescription:string = "MS-AZURE-SSL-0";
	//private AndroidSenderId:string = "1028433906542";       // YOUR_GCM_PROJECT_ID

  //https://ambit.maxxess-systems.com/AmbitMobileApi/api/mobile/TestDatabaseQueryTime?Client=Test
  private apiUrl:string = ""; // 'http://localhost:3000/products';

  private _geoPosition:GeoPosition;
  private _geoPositionMonitor:GeoPosition;
  private _apiReturn:ApiReturn = new ApiReturn();

  // specific function responses that are stored for retrieval when connection is down
  private _SavedDashboardStatusForMobile:any = null;
  private _SavedGetEventAssignedList:any = null;
  private _SavedGetEventAttentionList:any = null;
  private _SavedGetEventBroadcastedList:any = null;
  private _SavedGetEventBroadcastedList_System:any = null;
  private _SavedGetEventSubmittedList:any = null;
  private _SavedGetEventSubmittedList_System:any = null;
  private _SavedGetEventNotificationList:any = null;
  private _SavedGetAmbitMessageList:any = null;

  // --------------------------------------------------------------------------------
  // VALID API FUNCTION NAMES
  // --------------------------------------------------------------------------------

  apiName:any = 
  {
    // WARNING:  Do not change the parameter NAMES without checking throughout the Javascript
	  //           Do not change the parameter VALUES without checking the API web service code

    // -------------------------------------------------------------------- ADMIN
      TestServerResponseTime: 		 	    "TestServerResponseTime"
	  , TestDatabaseQueryTime: 		 	      "TestDatabaseQueryTime"
    // -------------------------------------------------------------------- REGISTRATION
    //, RegisterMobileWithAmbitSystem: 	  "RegisterMobileWithAmbitSystem" - Deprecate this
    , AmbitMobileLogin: 			 	        "AmbitMobileLogin"
    , IsFederatedUser:                  "IsFederatedUser"
    , RequestForgottenMobilePassword: 	"RequestForgottenMobilePassword" // ForgotPassword
    , RegisterMobileForPush: 		 	      "RegisterMobileForPush"
    // -------------------------------------------------------------------- LANGUAGE DATA
    , GetLanguageDataForMobile:         "GetLanguageDataForMobile"
    , GetLanguageListForMobile:         "GetLanguageListForMobile"
    // -------------------------------------------------------------------- DASHBOARD / ACTIONS
    , GetDashboardStatusForMobile:      "GetDashboardStatusForMobile"
    // -------------------------------------------------------------------- SURVEY BROADCAST
    , GetSurveyFormList:                "GetSurveyFormList"
    , MobileBroadcastSurvey:            "MobileBroadcastSurvey"
    , GetDepartmentInfoList:            "GetDepartmentInfoList"
    , GetSurveyResponseSummary:         "GetSurveyResponseSummary"  // 2018-01-02
    // ToDo -- ToDo:  create a new mobile API specifically to retrieve the survey
    // ToDo -- ToDo:  create a new mobile API specifically to retrieve the survey
    // ToDo -- ToDo:  create a new mobile API specifically to retrieve the survey
    , GetSurveyBroadcasted:             "RequestForSystemSurveyForm"  // 2018-01-04 // change to specific API
    // ToDo -- ToDo:  create a new mobile API specifically to retrieve the survey
    // ToDo -- ToDo:  create a new mobile API specifically to retrieve the survey
    // ToDo -- ToDo:  create a new mobile API specifically to retrieve the survey
    , MobileCloseSurvey:                "MobileCloseSurvey"
    , MobileReopenSurvey:               "MobileReopenSurvey"
    // -------------------------------------------------------------------- SURVEY RESPONSE
    , RequestForSystemSurveyForm: 		  "RequestForSystemSurveyForm"
    , ResponseToSystemSurveyForm: 		  "ResponseToSystemSurveyForm"
    , ReceivedNotificationForSystemSurvey: "ReceivedNotificationForSystemSurvey"
    , GetSurveyLatestByMobileUser:      "GetSurveyLatestByMobileUser"
    // -------------------------------------------------------------------- ACTIONABLE FORM (feature 12)
    , RequestForActionableForm:         "RequestForActionableForm"
    , ResponseToActionableForm:         "ResponseToActionableForm"
    , ReceivedNotificationForActionableForm: "ReceivedNotificationForActionableForm"
    // -------------------------------------------------------------------- QUESTIONNAIRE
    , RequestForQuestionnaire: 		      "RequestForQuestionnaire"
    , ResponseToQuestionnaire: 		      "ResponseToQuestionnaire"
    // -------------------------------------------------------------------- SUPPORT
    , RequestForMobileSupportForm: 		  "RequestForMobileSupportForm"
    , ResponseToMobileSupportForm: 		  "ResponseToMobileSupportForm"
    , GetSupport:                       "GetSupport"
    , UpdateSupport:                    "UpdateSupport"
    , AssignSupport:                    "AssignSupport"
    , UnassignSupport:                  "UnassignSupport"
    , CloseSupport:                     "CloseSupport"
    , ReopenSupport:                    "ReopenSupport"
    // -------------------------------------------------------------------- REPORT
    , RequestForMobileReportForm: 		  "RequestForMobileReportForm"   
    , ResponseToMobileReportForm: 		  "ResponseToMobileReportForm"
    , GetReport:                        "GetReport"
    , UpdateReport:                     "UpdateReport"
    , AssignReport:                     "AssignReport"
    , UnassignReport:                   "UnassignReport"
    , CloseReport:                      "CloseReport"
    , ReopenReport:                     "ReopenReport"
    // -------------------------------------------------------------------- CONFIDENTIAL
    , RequestForMobileConfidentialForm: "RequestForMobileConfidentialForm" 
    , ResponseToMobileConfidentialForm: "ResponseToMobileConfidentialForm" 
    , GetConfidential:                  "GetConfidential"
    , UpdateConfidential:               "UpdateConfidential"
    , AssignConfidential:               "AssignConfidential"
    , UnassignConfidential:             "UnassignConfidential"
    , CloseConfidential:                "CloseConfidential"
    , ReopenConfidential:               "ReopenConfidential"
    // -------------------------------------------------------------------- ANONYMOUS
    , RequestForMobileAnonymousForm:    "RequestForMobileAnonymousForm" 
    , ResponseToMobileAnonymousForm:    "ResponseToMobileAnonymousForm" 
    , GetAnonymous:                     "GetAnonymous"
    , UpdateAnonymous:                  "UpdateAnonymous"
    , AssignAnonymous:                  "AssignAnonymous"
    , UnassignAnonymous:                "UnassignAnonymous"
    , CloseAnonymous:                   "CloseAnonymous"
    , ReopenAnonymous:                  "ReopenAnonymous"
    // -------------------------------------------------------------------- MONITOR
    // , GetStatusForMobileMonitor:        "GetDashboardStatusForMobile"   // <<< NOTE!! Using dashboard for monitor status
    , GetStatusForMobileMonitor:        "GetStatusForMobileMonitor"   // 2020-01-16
    , SendMobileMonitorStatus:          "SendMobileMonitorStatus"
    , GetMonitor:                        "GetMonitor"
    , AssignMonitor:                     "AssignMonitor"
    , UnassignMonitor:                   "UnassignMonitor"
    // ToDo: need to create mobile API calls for these system like functions:
    , UpdateMonitor:                     "UpdateMonitor"          // <<< ToDo: NOT IMPLEMENTED YET AS MOBILE API
    , ForceCloseMonitor:                 "ForceCloseMonitor"      // <<< ToDo: NOT IMPLEMENTED YET AS MOBILE API
    , SendMonitorChatMessage:            "SendMonitorChatMessage" // <<< ToDo: NOT IMPLEMENTED YET AS MOBILE API
    , GetMonitorChatList:                "GetMonitorChatList" // <<< ToDo: NOT IMPLEMENTED YET AS MOBILE API
    /// -------------------------------------------------------------------- ACCESS
    , RequestForMobileAccessForm: 		  "RequestForMobileAccessForm"
    , ResponseToMobileAccessForm: 		  "ResponseToMobileAccessForm"
    // -------------------------------------------------------------------- DOOR CONTROL
    , RequestForMobileDoorControlForm:  "RequestForMobileDoorControlForm"
    , ResponseToMobileDoorControlForm: 	"ResponseToMobileDoorControlForm"
    // -------------------------------------------------------------------- CHECKIN
    , GetStatusForMobileCheckin_DASHBOARD: "GetDashboardStatusForMobile"   // <<< NOTE!! Using dashboard for checkin status
    , GetStatusForMobileCheckin:        "GetStatusForMobileCheckin"   // <<SWITCH TO THIS CALL!!
    , UpdateStatusForMobileCheckin:     "UpdateStatusForMobileCheckin"
    // -------------------------------------------------------------------- SITE
    //, GetSiteList:                      "GetSiteList"  -- deprecated 2017-12-16
    , GetSiteInfo:                      "GetSiteInfo"
    , GetSiteInfoList:                  "GetSiteInfoList" 
    , GetFloorPlanList:                 "GetFloorPlanList"
    // -------------------------------------------------------------------- AMBIT MESSAGE (feature 19) 
    , SendAmbitMessageAsPushToSelf:     "SendAmbitMessageAsPushToSelf"   
    , SendAmbitMessageAsEmailToSelf:    "SendAmbitMessageAsEmailToSelf"  
    , SendAmbitMessageAsTextToSelf:     "SendAmbitMessageAsTextToSelf"
    , GetAmbitMessage:                  "GetAmbitMessage"
    , GetAmbitMessageList:              "GetAmbitMessageList"
    , ReceivedAmbitMessage:             "ReceivedAmbitMessage"
    , UpdateAmbitMessage:               "UpdateAmbitMessage"
    , CloseAmbitMessage:                "CloseAmbitMessage"
    // -------------------------------------------------------------------- MEDIA
    , UploadMediaFile:                  "UploadMediaFile"
    , GetMediaContent:                  "image/GetMediaContent"
    , GetMediaContentForAlternateKey:   "image/GetMediaContentForAlternateKey"   // 2018
    , GetPersonPicture:                 "image/GetPersonPicture"
    // -------------------------------------------------------------------- ATTENTION
    , GetEventAssignedList:             "GetEventAssignedList"      
    , GetEventAttentionList:            "GetEventAttentionList"     
    , GetEventSubmittedList:            "GetEventSubmittedList"     
    , GetEventSubmittedList_System:     "GetEventSubmittedList_System"     // 2018-01-08     
    , GetEventBroadcastedList:          "GetEventBroadcastedList"          // 2017-12-27 - surveys sent by this mobile user
    , GetEventBroadcastedList_System:   "GetEventBroadcastedList_System"   // 2018-01-08
    , GetEventNotificationList:         "GetEventNotificationList"     // NOTE!!  uses AmbitMessageList but with EventNotificationFlag
    // -------------------------------------------------------------------- WORK CONTACTS
    , GetMobileUserWorkContactList:      "GetMobileUserWorkContactList"
    // -------------------------------------------------------------------- PERSONAL CONTACTS
    , GetMobileUserPersonalContactList:  "GetMobileUserPersonalContactList"
    , GetMobileUserPersonalContact:      "GetMobileUserPersonalContact"
    , AddMobileUserPersonalContact:      "AddMobileUserPersonalContact"
    , UpdateMobileUserPersonalContact:   "UpdateMobileUserPersonalContact"
    , DeleteMobileUserPersonalContact:   "DeleteMobileUserPersonalContact"
    // -------------------------------------------------------------------- EMERGENCY AUTODIAL
    , GetMobileUserEmergencyAutodialList:  "GetMobileUserEmergencyAutodialList"
    , GetMobileUserEmergencyAutodial:      "GetMobileUserEmergencyAutodial"
    , AddMobileUserEmergencyAutodial:      "AddMobileUserEmergencyAutodial"
    , UpdateMobileUserEmergencyAutodial:   "UpdateMobileUserEmergencyAutodial"
    , DeleteMobileUserEmergencyAutodial:   "DeleteMobileUserEmergencyAutodial"
    , SetActiveMobileUserEmergencyAutodial:   "SetActiveMobileUserEmergencyAutodial"
    , SetInactiveMobileUserEmergencyAutodial: "SetInactiveMobileUserEmergencyAutodial"
    // --------------------------------------------------------------------
  };

  isEncodeComponent:boolean = true;
  isEncodeUri:boolean = false;
  
  // --------------------------------------------------------------------------------

  constructor(
     public commonProvider: CommonService 
    , public http: HttpClient
    , public httpProxy: HTTP  // trying to avoid CORS issue when calling regular API
    
    //, private storage: Storage  // CONSOLIDATE THIS INTO global.ts
    , public globalProvider: GlobalService 
    , public runtime: RuntimeService 
    , public geolocationWrapperProvider: GeolocationWrapperService
  )
  {
    this.consoleLog = this.globalProvider.consoleLog_api;
    if (this.consoleLog) console.log('ApiProvider.ctor - LifeCycle');
    //this.ApiFunctionName = apiFunctionName;
    this.DetermineEncodeSettings();
  }

  DetermineEncodeSettings()
  {
    // ref:  https://github.com/silkimen/cordova-plugin-advanced-http/issues/149
    if (this.runtime.UseEncodeUri())
    {
      this.isEncodeUri = true;
      this.isEncodeComponent = false;
    }
    else
    {
      this.isEncodeUri = false;
      this.isEncodeComponent = true;
    }

    if (this.consoleLog) console.log('ApiProvider.DetermineEncodeSettings -' 
           + ' isEncodeUri:' + this.isEncodeUri
           + ' isEncodeComponent:' + this.isEncodeComponent
           )
           ;
  }

  DoEncodeComponent(value:string):string
  {
    if (this.isEncodeComponent)
    {
      return encodeURIComponent(value);
    }
    else
    {
      return value;
    }
  }

  DoEncodeUri(value:string):string
  {
    if (this.isEncodeUri)
    {
      return encodeURI(value);
    }
    else
    {
      return value;
    }
  }

  // --------------------------------------------------------------------------------
  // PRIVATE - GENERIC API CALL FUNCTIONS
  // --------------------------------------------------------------------------------

  private get(url):Promise<any> {
    if (this.runtime.UseHttpProxy()) {
      return this.httpProxy.get(url, {}, {}).then(response => JSON.parse(response.data));
    } else {
      return this.http.get(url).toPromise();
    }
  }

  // //////////
  // ////////// GET
  // //////////
  private CallAmbitMobileApiGet(functionName:string, functionSpecificQueryString:string):Promise<{}> 
  {
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet: ' + functionName);
    this.DetermineEncodeSettings();

    if (this.runtime.UseHttpProxy())
    {
      if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet: CORDOVA NATIVE PROXY ' + functionName); // 
      return this.CallAmbitMobileApiGet_Proxy(functionName, functionSpecificQueryString);
    }
    else
    {
      if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet: BROWSER WEB ORIGINAL ' + functionName); // http://localhost 
      return this.CallAmbitMobileApiGet_Browser(functionName, functionSpecificQueryString);
    }
  }

  // PROXY httpProxy - to avoid issue with running on device that assumes it is localhost and therefore runs into CORS issue with regular API
  private CallAmbitMobileApiGet_Proxy(functionName:string, functionSpecificQueryString:string):Promise<{}>
  {
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Proxy: ' + functionName);
    this.apiUrl = this.ApiFunctionUrl(functionName)
                + functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ;
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Proxy URL', this.apiUrl);

    if (this.isEncodeUri)
    {
      this.apiUrl = this.DoEncodeUri(this.apiUrl);
      if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Proxy URL ENCODED', this.apiUrl);
    }
        
    const StartDatetimeUtc = moment().utc();

    return new Promise( (resolve,reject) => {
      this.httpProxy.get(this.apiUrl, {}, {})
      .then(dataProxy => {
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Proxy RESPONSE OK - ' + functionName);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Proxy STATUS', dataProxy.status);
        //if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Proxy DATA', dataProxy.data); // data received by server
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Proxy HEADERS', dataProxy.headers);

        let data = JSON.parse(dataProxy.data);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Proxy JSON data', data); // data received by server
        this.globalProvider.SetStorageObject_MobileUserProfile(data);
        this.globalProvider.SetStorageObject_Dashboard(data, functionName);
        this.globalProvider.SetStorageObject_SiteProximity(data);
        //this.globalProvider.SetStorageObject_LanguageData(data); // may not come from other calls -- but just in case
        this.StoreApiResult(functionName, data);

        if (this.IsApiSuccessful(data))
        {
          //this.notificationProvider.CheckUnseenNotifications(data, this.pageName);  // if any
          resolve(data);
        }
        else 
        {
          //reject(this._apiReturn.ApiReturnText);
          reject(data);
        }
      }, errProxy => {
        console.warn('ApiProvider.CallAmbitMobileApiGet_Proxy RESPONSE ERROR - ' + functionName, errProxy);
        
        console.warn('ApiProvider.CallAmbitMobileApiGet_Proxy ERROR status', errProxy.status);
        console.warn('ApiProvider.CallAmbitMobileApiGet_Proxy ERROR error', errProxy.error); // error message as string
        console.warn('ApiProvider.CallAmbitMobileApiGet_Proxy ERROR headers', errProxy.headers);

        let err = errProxy.error;

        this.StoreApiError(functionName, err);
        let errorData:ApiResponse = this.SetDummyErrorApiResponse(functionName, err, StartDatetimeUtc);
        reject(errorData);
        //reject(err.message); // ToDo: maybe swap this returned message for a more user-friendly message
        //throw new Error(err.message);//here
      }
      );
    });
  }

  private CallAmbitMobileApiGet_Browser(functionName:string, functionSpecificQueryString:string):Promise<{}> 
  {
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Browser: ' + functionName);
    this.apiUrl = this.ApiFunctionUrl(functionName)
                + functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ;

    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Browser URL', this.apiUrl);
        
    const StartDatetimeUtc = moment().utc();
    const RoundtripStartMs:number = this.GetMetricsRoundtripStartMs(functionName);

    return new Promise( (resolve,reject) => {
      this.http.get(this.apiUrl)

      // changed to 60 seconds....survey broadcast is a little slow at the moment even though the API runs quickly
      .pipe( 
          timeout(60000)
      )

      .subscribe(data => 
      {
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet_Browser RESPONSE OK - ' + functionName, data);
        this.DetermineMetricsFromApiResponse(functionName, data, RoundtripStartMs);
        this.globalProvider.SetStorageObject_MobileUserProfile(data);
        this.globalProvider.SetStorageObject_Dashboard(data, functionName);
        this.globalProvider.SetStorageObject_SiteProximity(data);
        this.StoreApiResult(functionName, data);

        if (this.IsApiSuccessful(data))
        {
          //this.notificationProvider.CheckUnseenNotifications(data, this.pageName);  // if any
          resolve(data);
        }
        else 
        {
          //reject(this._apiReturn.ApiReturnText);
          reject(data);
        }
      }, err => {
        console.warn('ApiProvider.CallAmbitMobileApiGet_Browser RESPONSE ERROR - ' + functionName, err);
        this.StoreApiError(functionName, err);
        let errorData:ApiResponse = this.SetDummyErrorApiResponse(functionName, err, StartDatetimeUtc);
        reject(errorData);
        //reject(err.message); // ToDo: maybe swap this returned message for a more user-friendly message
        //throw new Error(err.message);//here
      });
    });
  }


  // //////////
  // ////////// POST BASE 64 DATA -- use this for photos on native -- and on browser???
  // //////////

  private CallAmbitMobileApiPostBase64Data(functionName:string, functionSpecificQueryString:string
    , uploadBase64Data:Blob, UploadBase64DataString:string
    , ContextFeatureId, ContextFeatureName, ContextName, ContextId, FileNameOriginal, FileNameAmbit, FileSize
    ):Promise<{}> 
  {
    console.log('ApiProvider.CallAmbitMobileApiPostBase64Data: ' + functionName);
    this.DetermineEncodeSettings();

    if (this.runtime.UseHttpProxy()) // && (!this.runtime.IsMobileWeb))
    {
      console.log('ApiProvider.CallAmbitMobileApiPostBase64Data: CORDOVA NATIVE PROXY');
      return this.CallAmbitMobileApiPostBase64Data_Proxy(functionName
             , functionSpecificQueryString, uploadBase64Data, UploadBase64DataString
             , ContextFeatureId, ContextFeatureName, ContextName, ContextId, FileNameOriginal, FileNameAmbit, FileSize );
    }
    else
    {
      console.log('ApiProvider.CallAmbitMobileApiPostBase64Data: BROWSER WEB ORIGINAL');
      return this.CallAmbitMobileApiPostBase64Data_Browser(functionName
             , functionSpecificQueryString, uploadBase64Data, UploadBase64DataString
             , ContextFeatureId, ContextFeatureName, ContextName, ContextId, FileNameOriginal, FileNameAmbit, FileSize );
    }
  }

  private CallAmbitMobileApiPostBase64Data_Proxy(functionName:string, functionSpecificQueryString:string
    , uploadBase64Data:Blob, UploadBase64DataString:string
    , ContextFeatureId:string, ContextFeatureName:string, ContextName:string, ContextId:string, FileNameOriginal:string, FileNameAmbit:string, FileSize:string 
    ):Promise<{}>  
  {
    console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy: ' + functionName);
    this.apiUrl = this.ApiFunctionUrl(functionName)
                + functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ; 
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy URL', this.apiUrl);
        
    if (this.isEncodeUri)
    {
      this.apiUrl = this.DoEncodeUri(this.apiUrl);
      if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy URL ENCODED', this.apiUrl);
    }

    let StartDatetimeUtc = moment().utc();
    
    // To Do -- DETERMINE HOW TO SETUP POST CALL WITH BASE64 DATA
    // To Do -- DETERMINE HOW TO SETUP POST CALL WITH BASE64 DATA
    // To Do -- DETERMINE HOW TO SETUP POST CALL WITH BASE64 DATA
    // To Do -- DETERMINE HOW TO SETUP POST CALL WITH BASE64 DATA
    //this.http.post('url here', {"title": "something"}, {"Content-Type": "application/json"})

    // To Do -- DETERMINE HOW TO SETUP POST CALL WITH BASE64 DATA
    // To Do -- DETERMINE HOW TO SETUP POST CALL WITH BASE64 DATA
    // To Do -- DETERMINE HOW TO SETUP POST CALL WITH BASE64 DATA
    // To Do -- DETERMINE HOW TO SETUP POST CALL WITH BASE64 DATA

    // ref:  https://medium.com/@jurerickporras/base64-encoded-image-to-cloud-vision-using-http-of-ionic-62f091cb2a9e

    // READ THIS!!
    // ref: https://github.com/approov/cordova-plugin-advanced-http

    //this.httpProxy.post("your/api/endpoint", {"fileName":"filedata"}, {"Authorization":"some auth"})


    /*
    HTTP.post(url: string, body: any, headers: any): Promise<HTTPResponse>
      Make a POST request
      @param url — The url to send the request to
      @param body — The body of the request
      @param headers — The headers to set for this request
    */

    /* { "image": {"content": uploadBase64Data_Proxy }
        , "features": [ { "type": "TEXT_DETECTION" } ]
        }
      */

    let uploadBase64Data_Proxy:string = UploadBase64DataString.replace("data:image/jpeg;base64,", "");
    let uploadBase64Data_Blob:Blob = uploadBase64Data; // the raw blob data
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy uploadBase64Data_Proxy LENGTH:' + uploadBase64Data_Proxy.length);
    // 21352 is the length of my Android photo
    // ApiAdditionalInfo: "Mismatching file lengths:
    //        'ambitUpload_20190427-000455_65509.jpg'[requested(qsparm): 0]  
    //        [uploaded(streamLength): 21352]  
    //        [converted(buffer.length): 16013]  
    //        [codePosition:41]

     //let FileSizeNumber = uploadBase64Data_Proxy.length; // 21352;  //

    let body:any = uploadBase64Data_Blob; // uploadBase64Data_Proxy;

    // comment these out later once we have the photos working for both
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy - uploadBase64Data_Blob:', uploadBase64Data_Blob);
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy - UploadBase64DataString:', UploadBase64DataString);
    

    /*
    let XFunctionName = "UploadMediaFile";
    let AccessControlAllowOrigin = "*";
    let ContentType = "multipart/form-data";
    let CacheControl = "no-cache";

    let headersString = 
      "{  'X-FunctionName'              : "  + '"' + XFunctionName.toString()       + '"' + 
      " , 'X-ContextFeatureId'          : "  + '"' + ContextFeatureId.toString()    + '"' + 
      " , 'X-ContextFeatureName'        : "  + '"' + ContextFeatureName.toString()  + '"' + 
      " , 'X-ContextName'               : "  + '"' + ContextName.toString()         + '"' + 
      " , 'X-ContextId'                 : "  + '"' + ContextId.toString()           + '"' +  
      " , 'X-File-NameOriginal'         : "  + '"' + FileNameOriginal.toString()    + '"' +  
      " , 'X-File-Name'                 : "  + '"' + FileNameAmbit.toString()       + '"' +  
      " , 'X-File-Size'                 : "  + '"' + FileSize.toString()            + '"' +  
      " , 'Access-Control-Allow-Origin' : "  + '"' + AccessControlAllowOrigin.toString() + '"' + 
      " , 'Content-Type'                : "  + '"' + ContentType.toString()         + '"' +   
      " , 'Cache-Control'               : "  + '"' + CacheControl.toString()        + '"' +  
      //, 'Authorization': this.basic 
      "}"
      ;
    */
    //let headers:any = JSON.parse(headersString);


    let headers:any = 
      { 'X-FunctionName'              :       'UploadMediaFile'
      , 'X-ContextFeatureId'          : "'" + ContextFeatureId + "'"
      , 'X-ContextFeatureName'        :       ContextFeatureName
      , 'X-ContextName'               :       ContextName
      , 'X-ContextId'                 : "'" + ContextId         + "'"
      , 'X-File-NameOriginal'         : "'" + FileNameOriginal  + "'"
      , 'X-File-Name'                 : "'" + FileNameAmbit     + "'"
      , 'X-File-Size'                 : "'" + FileSize          + "'"
      , 'Access-Control-Allow-Origin' :      '*'
      , 'Content-Type'                :      'multipart/form-data' 
      , 'Cache-Control'               :      'no-cache'
      //, 'Authorization': this.basic 
      };
    //if (this.consoleLog) 
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy headers', headers);
    
    //this.httpProxy.setDataSerializer('urlencoded');
    this.httpProxy.setDataSerializer('utf8');
    //this.httpProxy.setDataSerializer('json'); // .setDataSerializer('json');
    const RoundtripStartMs:number = this.GetMetricsRoundtripStartMs(functionName);
    
    return new Promise( (resolve,reject) => {
      //this.httpProxy.get(this.apiUrl, {}, {})
      this.httpProxy.post( this.apiUrl
                         , body
                         , headers
                         )
      .then(dataProxy => {
        this.DetermineMetricsFromApiResponse(functionName, dataProxy, RoundtripStartMs);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy RESPONSE OK - ' + functionName);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy STATUS', dataProxy.status);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy HEADERS', dataProxy.headers);

        let data = JSON.parse(dataProxy.data);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy JSON data', data); // data received by server
        this.globalProvider.SetStorageObject_MobileUserProfile(data);
        this.globalProvider.SetStorageObject_Dashboard(data, functionName);
        this.globalProvider.SetStorageObject_SiteProximity(data);
        this.StoreApiResult(functionName, data);

        if (this.IsApiSuccessful(data))
        {
          if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy - IsApiSuccessful:TRUE'); 
          resolve(data);
        }
        else 
        {
          console.warn('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy - IsApiSuccessful:FALSE'); 
          reject(data);
          //reject(this._apiReturn.ApiReturnText);
        }
      }, errProxy => {
        console.warn('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy RESPONSE ERROR - ' + functionName, errProxy);
        
        console.warn('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy ERROR message', errProxy.message);
        console.warn('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy ERROR status', errProxy.status);
        console.warn('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy ERROR error', errProxy.error); // error message as string
        console.warn('ApiProvider.CallAmbitMobileApiPostBase64Data_Proxy ERROR headers', errProxy.headers);

        //let errorMessage = errProxy.error;
        
        this.StoreApiError(functionName, errProxy);
        let errorData:ApiResponse = this.SetDummyErrorApiResponse(functionName, errProxy, StartDatetimeUtc);
        //let errorData:ApiResponse = this.SetDummyErrorApiResponse_Proxy(functionName, errorMessage, StartDatetimeUtc);
        
        reject(errorData);
        //reject(err.message); // ToDo: maybe swap this returned message for a more user-friendly message
        //throw new Error(err.message);//here
      });
    });
  }

  private CallAmbitMobileApiPostBase64Data_Browser(functionName:string, functionSpecificQueryString:string
    , uploadBase64Data:any, UploadBase64DataString:string
    , ContextFeatureId:string, ContextFeatureName:string, ContextName:string, ContextId:string, FileNameOriginal:string, FileNameAmbit:string, FileSize:string 
    ):Promise<{}>  
  {
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data: ' + functionName);
    this.apiUrl = this.ApiFunctionUrl(functionName)
                + functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ;
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data_Browser URL', this.apiUrl);
        
    let StartDatetimeUtc = moment().utc();
    
    // HEADERS -- still needed?
    // http://www.html5rocks.com/en/tutorials/cors/  -- the 'not so simple' method
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS
    // http://stackoverflow.com/questions/5686059/how-to-avoid-cross-domain-policy-in-jquery-ajax-for-consuming-wcf-service

    // USE THIS -- we need to stick with SYNCHRONOUS call as that is all the API supportd right now
    let headers = new HttpHeaders(
      { 'X-FunctionName':       'UploadMediaFile'
      , 'X-ContextFeatureId':   ContextFeatureId
      , 'X-ContextFeatureName': ContextFeatureName
      , 'X-ContextName':        ContextName
      , 'X-ContextId':          ContextId
      , 'X-File-NameOriginal':  FileNameOriginal
      , 'X-File-Name':          FileNameAmbit
      , 'X-File-Size':          FileSize.toString()
      , 'Access-Control-Allow-Origin': '*'   // TEST WITHOUT: ref: https://stackoverflow.com/questions/45749375/response-for-cors-preflight-is-405-method-not-allowed-error
      , 'Content-Type':         'multipart/form-data' 
      , 'Cache-Control':        'no-cache'
      //, 'Authorization': this.basic 
      }
    );
    let options = { headers: headers };
    const RoundtripStartMs:number = this.GetMetricsRoundtripStartMs(functionName);

    return new Promise( (resolve,reject) => {
      //this.http.post(_url, _body, _options)
      this.http.post(this.apiUrl, uploadBase64Data, options)
      .subscribe(data => {
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostBase64Data RESPONSE OK - ' + functionName, data);
        this.DetermineMetricsFromApiResponse(functionName, data, RoundtripStartMs);
        this.globalProvider.SetStorageObject_MobileUserProfile(data);
        this.globalProvider.SetStorageObject_Dashboard(data, functionName);
        this.globalProvider.SetStorageObject_SiteProximity(data);
        this.StoreApiResult(functionName, data);

        if (this.IsApiSuccessful(data))
        {
          resolve(data);
        }
        else 
        {
          reject(data);
          //reject(this._apiReturn.ApiReturnText);
        }
      }, err => {
        console.warn('ApiProvider.CallAmbitMobileApiPostBase64Data RESPONSE ERROR - ' + functionName, err);
        this.StoreApiError(functionName, err);
        let errorData:ApiResponse = this.SetDummyErrorApiResponse(functionName, err, StartDatetimeUtc);
        reject(errorData);
        //reject(err.message); // ToDo: maybe swap this returned message for a more user-friendly message
        //throw new Error(err.message);//here
      });
    });
  }

  // //////////
  // ////////// POST FORM DATA -- might not be being used -- maybe ignore for now
  // //////////

  private CallAmbitMobileApiPostFormData(functionName:string, functionSpecificQueryString:string
    , uploadFormData:FormData, options:any ):Promise<{}>  
  {
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData: ' + functionName);
    this.DetermineEncodeSettings();

    if (this.runtime.UseHttpProxy())
    {
      console.log('ApiProvider.CallAmbitMobileApiPostFormData: CORDOVA NATIVE PROXY');
      return this.CallAmbitMobileApiPostFormData_Proxy(functionName, functionSpecificQueryString, uploadFormData, options);
    }
    else
    {
      console.log('ApiProvider.CallAmbitMobileApiPostFormData: BROWSER WEB ORIGINAL');
      return this.CallAmbitMobileApiPostFormData_Browser(functionName, functionSpecificQueryString, uploadFormData, options);
    }
  }

  // PROXY httpProxy - to avoid issue with running on device that assumes it is localhost and therefore runs into CORS issue with regular API
  private CallAmbitMobileApiPostFormData_Proxy(functionName:string, functionSpecificQueryString:string
    , uploadFormData:FormData, options:any ):Promise<{}> 
  {
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Proxy: ' + functionName);
    this.apiUrl = this.ApiFunctionUrl(functionName)
                + functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ;
    
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Proxy URL', this.apiUrl);
        
    if (this.isEncodeUri)
    {
      this.apiUrl = this.DoEncodeUri(this.apiUrl);
      if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Proxy URL ENCODED', this.apiUrl);
    }

    const StartDatetimeUtc = moment().utc();
    const RoundtripStartMs:number = this.GetMetricsRoundtripStartMs(functionName);

    return new Promise( (resolve,reject) => {
      //this.httpProxy.post(this.apiUrl, {}, {})  // uploadFormData, options
      this.httpProxy.post(this.apiUrl, uploadFormData, options)  // uploadFormData, options
      .then(dataProxy => {
        this.DetermineMetricsFromApiResponse(functionName, dataProxy, RoundtripStartMs);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Proxy RESPONSE OK - ' + functionName);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Proxy STATUS', dataProxy.status);
        //if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Proxy DATA', dataProxy.data); // data received by server
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Proxy HEADERS', dataProxy.headers);

        let data = JSON.parse(dataProxy.data);
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Proxy JSON data', data); // data received by server
        this.globalProvider.SetStorageObject_MobileUserProfile(data);
        this.globalProvider.SetStorageObject_Dashboard(data, functionName);
        this.globalProvider.SetStorageObject_SiteProximity(data);
        this.StoreApiResult(functionName, data);

        if (this.IsApiSuccessful(data))
        {
          resolve(data);
        }
        else 
        {
          reject(data);
          //reject(this._apiReturn.ApiReturnText);
        }
      }, errProxy => {
        console.warn('ApiProvider.CallAmbitMobileApiPostFormData_Proxy RESPONSE ERROR - ' + functionName, errProxy);
        
        console.warn('ApiProvider.CallAmbitMobileApiPostFormData_Proxy ERROR status', errProxy.status);
        console.warn('ApiProvider.CallAmbitMobileApiPostFormData_Proxy ERROR error', errProxy.error); // error message as string
        console.warn('ApiProvider.CallAmbitMobileApiPostFormData_Proxy ERROR headers', errProxy.headers);

        let err = errProxy.error;  // JSON.parse(

        this.StoreApiError(functionName, err);
        let errorData:ApiResponse = this.SetDummyErrorApiResponse(functionName, err, StartDatetimeUtc);
        reject(errorData);
        //reject(err.message); // ToDo: maybe swap this returned message for a more user-friendly message
        //throw new Error(err.message);//here
      });
    });
  }

  private CallAmbitMobileApiPostFormData_Browser(functionName:string, functionSpecificQueryString:string
    , uploadFormData:FormData, options:any ):Promise<{}> 
  {
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Browser: ' + functionName);
    this.apiUrl = this.ApiFunctionUrl(functionName)
                + functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ;
    
    const StartDatetimeUtc = moment().utc();
    const RoundtripStartMs:number = this.GetMetricsRoundtripStartMs(functionName);
    
    return new Promise( (resolve,reject) => {
      //this.http.post(_url, _body, _options)
      //this.http.post(_url, _body)
      this.http.post(this.apiUrl, uploadFormData, options)
      .subscribe(data => {
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFormData_Browser RESPONSE OK - ' + functionName, data);
        this.DetermineMetricsFromApiResponse(functionName, data, RoundtripStartMs);
        this.globalProvider.SetStorageObject_MobileUserProfile(data);
        this.globalProvider.SetStorageObject_Dashboard(data, functionName);
        this.globalProvider.SetStorageObject_SiteProximity(data);
        this.StoreApiResult(functionName, data);

        if (this.IsApiSuccessful(data))
        {
          resolve(data);
        }
        else 
        {
          reject(data);
          //reject(this._apiReturn.ApiReturnText);
        }
      }, err => {
        console.warn('ApiProvider.CallAmbitMobileApiPostFormData_Browser RESPONSE ERROR - ' + functionName, err);
        this.StoreApiError(functionName, err);
        let errorData:ApiResponse = this.SetDummyErrorApiResponse(functionName, err, StartDatetimeUtc);
        reject(errorData);
        //reject(err.message); // ToDo: maybe swap this returned message for a more user-friendly message
        //throw new Error(err.message);//here
      });
    });
  }

  // //////////
  // ////////// POST FILE -- might not be being used -- maybe ignore for now
  // //////////
  private CallAmbitMobileApiPostFile(functionName:string, functionSpecificQueryString:string
    , uploadFile:File, options:any ):Promise<{}>  
  {
    console.log('ApiProvider.CallAmbitMobileApiPostFile: ' + functionName);
    this.DetermineEncodeSettings();

    this.apiUrl = this.ApiFunctionUrl(functionName)
                + functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ;
    
    let StartDatetimeUtc = moment().utc();

    /*
      (method) HttpClient.post(url: string, body: any, options: {
          headers?: HttpHeaders | {
              [header: string]: string | string[];
          };
          observe?: "body";
          params?: HttpParams | {
              [param: string]: string | string[];
          };
          reportProgress?: boolean;
          responseType: "arraybuffer";
          withCredentials?: boolean;
      }): Observable<...> (+14 overloads)

      Construct a POST request which interprets the body as an ArrayBuffer and returns it.
    */

    //let _body:any = selectedFile;
    //let _options:any = { reportProgress: true
    //                   , observe: 'events'
    //                   }
    const RoundtripStartMs:number = this.GetMetricsRoundtripStartMs(functionName);

    return new Promise( (resolve,reject) => {
      //this.http.post(_url, _body, _options)
      this.http.post(this.apiUrl, uploadFile, options)
      .subscribe(data => {
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiPostFile RESPONSE OK - ' + functionName, data);
        this.DetermineMetricsFromApiResponse(functionName, data, RoundtripStartMs);
        this.globalProvider.SetStorageObject_MobileUserProfile(data);
        this.globalProvider.SetStorageObject_Dashboard(data, functionName);
        this.globalProvider.SetStorageObject_SiteProximity(data);
        this.StoreApiResult(functionName, data);

        if (this.IsApiSuccessful(data))
        {
          resolve(data);
        }
        else 
        {
          reject(data);
          //reject(this._apiReturn.ApiReturnText);
        }
      }, err => {
        console.warn('ApiProvider.CallAmbitMobileApiPostFile RESPONSE ERROR - ' + functionName, err);
        this.StoreApiError(functionName, err);
        let errorData:ApiResponse = this.SetDummyErrorApiResponse(functionName, err, StartDatetimeUtc);
        reject(errorData);
        //reject(err.message); // ToDo: maybe swap this returned message for a more user-friendly message
        //throw new Error(err.message);//here
      });
    });
  }
  // =======================================================================================

  private GetTimeMilliseconds():number
  {
    return new Date().getTime();
  }

  private GetMetricsRoundtripStartMs(functionName:string):number
  {
    const RoundtripStartMs:number = this.GetTimeMilliseconds();
    if (this.consoleLog) console.log("api.Metrics - " + functionName + " - RoundtripStartMs:" + RoundtripStartMs);
    return RoundtripStartMs;
  }

  private DetermineMetricsFromApiResponse(functionName:string, apiResponse:any, RoundtripStartMs:number)
  {
    if ((!apiResponse) || (!apiResponse.ApiReturn))
    {
      console.error("api.metrics: No ApiResponse to analyze");
      return;
    }

    // temp check until this has been implemented and verified across all mobile API calls
    //if (!apiResponse.ApiReturn.RoundtripStartMs)
    //{
    //  console.warn("api.metrics: ApiReturn.RoundtripStartMs not found");
    //  return;
    //}

    this.DetermineMetrics(functionName
                        , apiResponse.ApiReturn.ApiFunctionId
                        , apiResponse.ApiReturn.ApiLogId
                        , apiResponse.ApiReturn.ApiMilliseconds
                        , RoundtripStartMs // apiResponse.ApiReturn.RoundtripStartMs
                        );
  }

  public DetermineMetrics(functionName:string, ApiFunctionId:number
  , ApiLogId:number, ApiMilliseconds:number, RoundtripStartMs:number)
  {
    const RoundtripEndMs:number = this.GetTimeMilliseconds();
    const RoundtripMs = RoundtripEndMs - RoundtripStartMs;
    const NetworkMs = RoundtripMs - ApiMilliseconds;

    // ToDo:
    // group association based on user-interaction
    // - multiple API calls may result based on that one interaction
    // - ability to aggregate metrics based on multiple calls 

    // add this to an internal "list"
    // - 1. for display on the client itself
    // - 2. echo the list to the backend API on a future call
    //      (and clear that echoed list)  &apiMetrics=127351572|43|45|123891239|

    // save the metrics and lazily send it back to as a small payload in a future API call
    this.globalProvider.Metrics.SetMetrics(ApiFunctionId, ApiLogId, ApiMilliseconds, RoundtripMs, NetworkMs);

    //if (this.consoleLog) 
    console.log("api.Metrics -" 
    + " ApiLogId:" + ApiLogId + " -"
    + " RoundtripMs:" + RoundtripMs
    + " NetworkMs:" + NetworkMs
    + " ApiMilliseconds:" + ApiMilliseconds
    + " - " + functionName + "(" + ApiFunctionId + ")"
    );
  }

  // =======================================================================================

  private SetDummyErrorApiResponse(functionName, errorObject, StartDatetimeUtc):ApiResponse
  {
    // in the absence of a true ApiResponse object, make one up here to give some useful information
    console.log("ApiProvider.SetErrorApiReturn", errorObject);
    let apiResponse:ApiResponse = new ApiResponse();

    let EndDatetimeUtc = moment().utc(); 
    let Duration = moment.duration(EndDatetimeUtc.diff(StartDatetimeUtc));
    let ApiMilliSeconds = Duration.asMilliseconds();

    apiResponse.ApiReturn.AmbitFeatureId = "";
    apiResponse.ApiReturn.ApiAdditionalInfo = "Server communication error";
    apiResponse.ApiReturn.ApiAuthenticatedFlag = "";
    apiResponse.ApiReturn.FunctionName = functionName;
    apiResponse.ApiReturn.ApiLogId = "";
    apiResponse.ApiReturn.ApiMilliseconds = ApiMilliSeconds.toString();
    //public ApiSeconds:string = "";
    apiResponse.ApiReturn.ApiReturnCode = "ERR99";
    apiResponse.ApiReturn.ApiReturnText = errorObject.message;
    apiResponse.ApiReturn.ApiSuccessCode = "FATAL";
    apiResponse.ApiReturn.ApiSuccessFlag = false;
    apiResponse.ApiReturn.ApiVersion = "";
    apiResponse.ApiReturn.Description = "";
    apiResponse.ApiReturn.StartDatetimeUtc = StartDatetimeUtc.format("YYYY-MM-DDTHH:mm:ss") + "Z";
    apiResponse.ApiReturn.EndDatetimeUtc = EndDatetimeUtc.format("YYYY-MM-DDTHH:mm:ss") + "Z"; // "DT-Z"; 

    return apiResponse;
  }

  // =======================================================================================

  private IsApiSuccessful(data:any):boolean
  {
    this._apiReturn.Initialize();

    if (this.consoleLog) console.log('ApiProvider.IsApiSuccessful - checking exists: data');
    if (!data) 
    {  
      console.warn('ApiProvider.IsApiSuccessful - missing data', data);
      return false; 
    }

    if (this.consoleLog) console.log('ApiProvider.IsApiSuccessful - checking exists: data.ApiReturn');
    if (!data.ApiReturn) 
    {  
      console.warn('ApiProvider.IsApiSuccessful - missing data.ApiReturn', data);
      return false; 
    }

    this._apiReturn.SetApiReturn(data.ApiReturn);
    return this._apiReturn.ApiSuccessFlag;
  }

  private CallAmbitMobileApiGetMedia(functionName:string, functionSpecificQueryString:string):string 
  {
    if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGetMedia: ' + functionName);
    this.apiUrl = this.ApiFunctionUrl(functionName)
                + functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ;
    return this.apiUrl;
  }

  private StoreApiResult(functionName:string, data:any)
  {
    if (functionName === this.apiName.GetDashboardStatusForMobile)
    {
      this._SavedDashboardStatusForMobile = data;
      this.globalProvider.SetStorageObject_ApiData(data, 'SavedDashboardStatusForMobile');
    }
    else if (functionName === this.apiName.GetEventAssignedList)
    {
      this._SavedGetEventAssignedList = data;
      this.globalProvider.SetStorageObject_ApiData(data, 'SavedGetEventAssignedList');
    }
    else if (functionName === this.apiName.GetEventAttentionList)
    {
      this._SavedGetEventAttentionList = data;
      this.globalProvider.SetStorageObject_ApiData(data, 'SavedGetEventAttentionList');
    }
    else if (functionName === this.apiName.GetEventBroadcastedList)
    {
      this._SavedGetEventBroadcastedList = data;
      this.globalProvider.SetStorageObject_ApiData(data, 'SavedGetEventBroadcastedList');
    }
    else if (functionName === this.apiName.GetEventBroadcastedList_System)
    {
      this._SavedGetEventBroadcastedList_System = data;
      this.globalProvider.SetStorageObject_ApiData(data, 'SavedGetEventBroadcastedList_System');
    }
    else if (functionName === this.apiName.GetEventSubmittedList)
    {
      this._SavedGetEventSubmittedList = data;
      this.globalProvider.SetStorageObject_ApiData(data, 'SavedGetEventSubmittedList');
    }
    else if (functionName === this.apiName.GetEventSubmittedList_System)
    {
      this._SavedGetEventSubmittedList_System = data;
      this.globalProvider.SetStorageObject_ApiData(data, 'SavedGetEventSubmittedList_System');
    }
    else if (functionName === this.apiName.GetEventNotificationList)
    {
      this._SavedGetEventNotificationList = data;
      this.globalProvider.SetStorageObject_ApiData(data, 'SavedGetEventNotificationList');
    }
  }

  private StoreApiError(functionName:string, err:any)
  {
    try
    {
      this.globalProvider.LastApiError.ErrorFlag = true;
      this.globalProvider.LastApiError.ApiFunctionName = functionName;
      this.globalProvider.LastApiError.Message = (err && err.message) || err;
      this.globalProvider.LastApiError.StatusText = (err && err.statusText) || 'N/A';
      this.globalProvider.LastApiError.Name = (err && err.name) || 'N/A';
      this.globalProvider.LastApiError.ApiDatetime = moment().format("YYYY-MM-DDTHH:mm:ss");
    }
    catch(error)
    {
      console.warn('ApiProvider.StoreApiError ERROR', error);
    }
  }

  //private CallAmbitObservable(functionName): Observable<Object> 
  //{
  //  if (this.consoleLog) console.log('ApiProvider.CallAmbitObservable: ' + functionName);
  //  this.apiUrl = this.ApiFunctionUrl(functionName);
  //  return this.http.get(this.apiUrl);
  //}

  // --------------------------------------------------------------------------------
  // PRIVATE - USE STORAGE FOR KEY ITEMS ABOUT MOBILE USER THAT MAY BE RETURNED
  // --------------------------------------------------------------------------------
  // private StoreUserProfileFromDashboardCall(data) -- MOVED INTO global.ts
  // private StoreAppDisplayInfo(data) -- MOVED INTO global.ts
  // private StoreApiData(data:any, dataName:string) -- MOVED INTO global.ts

  // --------------------------------------------------------------------------------
  // PRIVATE - SUPPORTING FUNCTIONS
  // --------------------------------------------------------------------------------

  ApiRelativeUrl(relativeUrl):string
  {
    // we shouldn't need two api urls (one cors, one not)
    // but until we can reconfigure production....
    const apiUrl = this.UseCors() ? environment.apiCorsUrl : environment.apiUrl;
    return `${apiUrl}${relativeUrl}`;
  }

  ApiFunctionUrl(functionName):string
  {
    return `${this.ApiRelativeUrl(functionName)}?Client=App`;
  }

  UseCors():boolean
  {
    const isCors = this.runtime.IsCors();

    const forceNoCors = this.globalProvider.AmbitConfig.Override_1Cors_2NoCors_0Default === 2;
    if (isCors && forceNoCors)
    {
      console.warn("Api.UseCors: overriding CORS with NONE");
      return false;
    }

    const forceCors = this.globalProvider.AmbitConfig.Override_1Cors_2NoCors_0Default === 1;
    if (!isCors && forceCors) {
      console.warn("Api.UseCors: overriding NONE with CORS");
      return true;
    }

    if (this.consoleLog) console.log("Api.UseCors [value=" + isCors + "]");
    return isCors;
  }

  ApiCommonQueryString(functionName:string)
  {
    // see myCommonCode.js
    // root.AmbitApiUrl = function(functionName, ApiPosition)

    let isPanicApp = this.globalProvider.isPanicApp;
    let MobileAppId = this.globalProvider.MobileAppId;
    
    let MobileDatetime = moment().format("YYYY-MM-DDTHH:mm:ss"); // "DT-L"; "2018-02-28T23:59:59:59"; // 
    let MobileDatetimeUtc = moment().utc().format("YYYY-MM-DDTHH:mm:ss") + "Z"; // "DT-Z"; "2018-02-28T23:59:59:59Z"; // 
    let MobileSendGuid = this.generateUUID(); // "65dce385-0240-483f-ae16-6298cca9429d"; // uuid.v4();   
    
    // these value identifies the mobile device and/or its organization
    let OrganizationId = this.globalProvider.MobileUserProfile.OrganizationId;    
    let OrganizationCode = this.globalProvider.MobileUserProfile.OrganizationCode;    // "MAXXESS";   
    let MobileDeviceGuid = this.globalProvider.MobileUserProfile.MobileDeviceGuid; 
    if (this.consoleLog) console.log("api.ApiCommonQueryString MobileUserProfile", this.globalProvider.MobileUserProfile);
    
    // device information -- should be pretty static but in case details change 
    let DeviceTypeCode = this.runtime.GetDeviceTypeCode();
    let DeviceBrandCode = this.runtime.GetDeviceBrandCode();
    let DevicePlatformCode = this.runtime.GetDevicePlatformCode();
    let DeviceProductCode = this.runtime.GetDeviceProductCode();
    let DeviceOsVersionCode = this.runtime.GetDeviceOsVersionCode();
    let AmbitMobileAppRunContext = this.runtime.GetAmbitMobileAppRunContext();
    let NativeDeviceUuid = this.runtime.GetNativeDeviceUuid();
    let DeviceCarrierCode = this.runtime.GetDeviceCarrierCode(); 

    // these values are fairly static across all calls
    let MobileAppTypeCode = this.runtime.GetRuntimeName(); // __IonicRunContext__;
    let MobileAppVersionCode = this.globalProvider.AmbitConfig.AmbitMobileAppVersion;
    let ApiServiceEnvironment = this.globalProvider.AmbitConfig.ApiServiceEnvironment;

    let queryString = ( (isPanicApp) ? ("&isPanicApp=" + isPanicApp) : ("") ) 
                    + "&MobileAppId=" + MobileAppId  
                    + "&MobileSendGuid=" + this.DoEncodeComponent(MobileSendGuid)  
                    + "&MobileDeviceGuid=" + this.DoEncodeComponent(MobileDeviceGuid) 
                    + "&OrganizationId=" + OrganizationId    
                    + "&OrganizationCode=" + this.DoEncodeComponent(OrganizationCode)     
                    + "&MobileDatetime=" + this.DoEncodeComponent(MobileDatetime)
                    + "&MobileDatetimeUtc=" + this.DoEncodeComponent(MobileDatetimeUtc)
                    + "&MobileAppTypeCode=" + this.DoEncodeComponent(MobileAppTypeCode)
                    + "&MobileAppVersionCode=" + this.DoEncodeComponent(MobileAppVersionCode)
                    + "&ApiServiceEnvironment=" + this.DoEncodeComponent(ApiServiceEnvironment)
                    + "&AmbitMobileAppRunContext=" + this.DoEncodeComponent(AmbitMobileAppRunContext)

                    + "&DeviceCarrierCode=" + this.DoEncodeComponent(DeviceCarrierCode)
                    //  +  "&MessagePushTypeCode=" + ambitUa.MessagePushTypeCode            // ToDo: maybe just let the webservice determine the push type
                    + "&DeviceTypeCode=" + this.DoEncodeComponent(DeviceTypeCode)
                    + "&DevicePlatformCode=" + this.DoEncodeComponent(DevicePlatformCode)  // Ios / Android
                    + "&DeviceBrandCode=" + this.DoEncodeComponent(DeviceBrandCode)        
                    + "&DeviceProductCode=" + this.DoEncodeComponent(DeviceProductCode)    // iPhone 7,1 / sgh-m919
                    + "&DeviceOsVersionCode=" + this.DoEncodeComponent(DeviceOsVersionCode)
                    + "&NativeDeviceUuid=" + this.DoEncodeComponent(NativeDeviceUuid)
                    + this.GetLatestLocationQueryString(functionName)
                    + this.GetPushInformation(functionName)
                    + "&RoundtripStartMs=" + this.GetMetricsRoundtripStartMs(functionName)
                    + this.globalProvider.GetMetrics_QueryString() //.Metrics.GetQueryString()
                   //+  "&UserAgent=" +  this.DoEncodeComponent(ambitUa.DetermineUserAgent()); 
                    // include native device values (even if empty as with mobile web app, since AmbitMobileLogin requires it)
                    ;
    this.globalProvider.Metrics.ResetQueryString();

    return queryString;
  }
  
  generateUUID():string
  { 
    // this may not be perfect, but it's "good enough" for my purposes where I want
    // to be able to search across logs, files and DB records for a specific API call
    // for which I would probably be restricting to some date or time range anyway
    // Public Domain/MIT - ref: https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
    try
    {
      let d = new Date().getTime();
      if (typeof performance !== 'undefined' && typeof performance.now === 'function')
      {
        d += performance.now(); //use high-precision timer if available
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) 
      {
  // tslint:disable-next-line: no-bitwise
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
  // tslint:disable-next-line: no-bitwise
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }
    catch (error)
    {
      console.warn("api.generateUUID error", error);
      return "65dce385-0240-483f-ae16-6298cca9429d"; // just because we need something....
    }
  }

  // --------------------------------------------------------------------------------
  // PUBLIC - SPECIFIC API CALL FUNCTIONS
  // --------------------------------------------------------------------------------

  public TestBadApiCall()
  {
    if (this.consoleLog) console.log("TestBadApiCall");
    //return this.CallAmbitMobileApiGet(this.apiFunctionName.TestDatabaseQueryTime);
    this.apiUrl = "http://adfjashdfhasf.com/";

    return new Promise(resolve => {
      this.http.get(this.apiUrl).subscribe(data => {
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet RESPONSE OK', data);
          resolve(data);
      }, err => {
        if (this.consoleLog) console.log('ApiProvider.CallAmbitMobileApiGet RESPONSE ERROR', err);
        if (this.consoleLog) console.log(err);
        resolve(err);
      });
    });
  }

  // -------------------------------------------------------------------- ADMIN

  public TestServerResponseTime()
  {
    let queryString = "";
    return this.CallAmbitMobileApiGet(this.apiName.TestServerResponseTime, queryString); 
  }

  public TestDatabaseQueryTime(param1, param2)
  {
    let queryString = "&param1=" + param1
                    + "&param2=" + this.DoEncodeComponent(param2)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.TestDatabaseQueryTime, queryString); 
  }

  // -------------------------------------------------------------------- REGISTRATION
  
  public AmbitMobileLogin(MobileUsername, MobilePassword, NewMobilePassword)
  {
    let queryString = "&MobileUsername=" + this.DoEncodeComponent(MobileUsername)
    + "&MobilePassword=" + this.DoEncodeComponent(MobilePassword)
    ;

    if (Boolean(NewMobilePassword))
    { queryString = queryString + "&NewMobilePassword=" + this.DoEncodeComponent(NewMobilePassword); }

    return this.CallAmbitMobileApiGet(this.apiName.AmbitMobileLogin, queryString); 
  }

  public AmbitMobileLogin_Federated(FederationLoginToken)
  {
    let queryString = "&FederationLoginToken=" + this.DoEncodeComponent(FederationLoginToken);

    return this.CallAmbitMobileApiGet(this.apiName.AmbitMobileLogin, queryString); 
  }

  public IsFederatedUser(username)
  {
    let queryString = "&MobileUsername=" + username
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.IsFederatedUser, queryString); 
  }

  public GetFederatedAuthRequest(username) {
    const url = this.ApiRelativeUrl(`saml/auth?UserName=${username}`);
    return this.get(url);
  }

  public GetFederatedLogoutRequest(username, sessionIndex) {
    const url = this.ApiRelativeUrl(`saml/slo?UserName=${username}&SessionIndex=${sessionIndex}`);
    return this.get(url);
  }

  public RequestForgottenMobilePassword(EmailAddress)
  {
    let queryString = "&EmailAddress=" + EmailAddress
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RequestForgottenMobilePassword, queryString); 
  }

  // -------------------------------------------------------------------- PUSH ALERTS

  public RegisterMobileForPush(PushType, PushUrl):Promise<{}>
  {
    let queryString = "&PushUrl=" + PushUrl
                    + "&PushType=" + PushType
                    + "&ContextName=AppController"
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RegisterMobileForPush, queryString); 
  }
  
  // -------------------------------------------------------------------- LANGUAGE DATA

  public GetLanguageListForMobile():Promise<{}>
  {
    let queryString = "";
    return this.CallAmbitMobileApiGet(this.apiName.GetLanguageListForMobile, queryString); 
  }

  public GetLanguageDataForMobile(LanguageId):Promise<{}>
  {
    let queryString = "&LanguageId=" + LanguageId;
    return this.CallAmbitMobileApiGet(this.apiName.GetLanguageDataForMobile, queryString); 
  }

  public GetLanguageDataForMobile_URL(LanguageId):string   // NOTE!  Not a promise -- just the URL
  {
    let functionName = this.apiName.GetLanguageDataForMobile;
    let queryString = "&LanguageId=" + LanguageId;

    if (this.consoleLog) console.log('ApiProvider.GetLanguageDataForMobile_URL: ' + functionName);
    this.apiUrl = this.ApiFunctionUrl(functionName)
                + queryString // functionSpecificQueryString
                + this.ApiCommonQueryString(functionName) // CommonCode.AmbitApiUrl();
                ;
    return this.apiUrl;
  }
  
  // -------------------------------------------------------------------- DASHBOARD / ACTIONS
  
  public GetDashboardStatusForMobile():Promise<{}>
  {
    let queryString = "";
    return this.CallAmbitMobileApiGet(this.apiName.GetDashboardStatusForMobile, queryString); 
  }

  public RestoreDashboardStatusForMobile()
  {
    return this._SavedDashboardStatusForMobile; 
  }
  public Restore_SavedGetEventAssignedList()
  {
    return this._SavedGetEventAssignedList; 
  }
  public Restore_SavedGetEventAttentionList()
  {
    return this._SavedGetEventAttentionList; 
  }
  public Restore_SavedGetEventBroadcastedList()
  {
    return this._SavedGetEventBroadcastedList; 
  }
  public Restore_SavedGetEventBroadcastedList_System()
  {
    return this._SavedGetEventBroadcastedList_System; 
  }
  public Restore_SavedGetEventSubmittedList()
  {
    return this._SavedGetEventSubmittedList; 
  }
  public Restore_SavedGetEventSubmittedList_System()
  {
    return this._SavedGetEventSubmittedList_System; 
  }
  public Restore_SavedGetEventNotificationList()
  {
    return this._SavedGetEventNotificationList; 
  }
  public Restore_SavedGetAmbitMessageList()
  {
    return this._SavedGetAmbitMessageList; 
  }

  
  

  // -------------------------------------------------------------------- SIDEMENU / SUBMITTED
  
  public GetEventSubmittedList(LiveFlag:boolean):Promise<{}>
  {
    //let queryString = "&LiveFlag=" + LiveFlag;
    let queryString = this.commonProvider.GetQsLiveEventsFilter(LiveFlag, this.isEncodeComponent);
    return this.CallAmbitMobileApiGet(this.apiName.GetEventSubmittedList, queryString); 
  }

  public GetEventSubmittedList_System(LiveFlag:boolean):Promise<{}>
  {
    //let queryString = "&LiveFlag=" + LiveFlag;
    let queryString = this.commonProvider.GetQsLiveEventsFilter(LiveFlag, this.isEncodeComponent);
    return this.CallAmbitMobileApiGet(this.apiName.GetEventSubmittedList_System, queryString); 
  }

  // -------------------------------------------------------------------- SIDEMENU / BROADCASTED
  
  public GetEventBroadcastedList(LiveFlag:boolean):Promise<{}>
  {
    //let queryString = "&LiveFlag=" + LiveFlag;
    let queryString = this.commonProvider.GetQsLiveEventsFilter(LiveFlag, this.isEncodeComponent);
    return this.CallAmbitMobileApiGet(this.apiName.GetEventBroadcastedList, queryString); 
  }

  public GetEventBroadcastedList_System(LiveFlag:boolean):Promise<{}>
  {
    //let queryString = "&LiveFlag=" + LiveFlag;
    let queryString = this.commonProvider.GetQsLiveEventsFilter(LiveFlag, this.isEncodeComponent);
    return this.CallAmbitMobileApiGet(this.apiName.GetEventBroadcastedList_System, queryString); 
  }

  // -------------------------------------------------------------------- SIDEMENU / ASSIGNED
  
  public GetEventAssignedList(LiveFlag:boolean):Promise<{}>
  {
    //let queryString = "&LiveFlag=" + LiveFlag;
    let queryString = this.commonProvider.GetQsLiveEventsFilter(LiveFlag, this.isEncodeComponent);
    return this.CallAmbitMobileApiGet(this.apiName.GetEventAssignedList, queryString); 
  }

  // -------------------------------------------------------------------- SIDEMENU / ASSIGNED
  
  public GetEventAttentionList(LiveFlag:boolean):Promise<{}>
  {
    //let queryString = "&LiveFlag=" + LiveFlag;
    let queryString = this.commonProvider.GetQsLiveEventsFilter(LiveFlag, this.isEncodeComponent);
    return this.CallAmbitMobileApiGet(this.apiName.GetEventAttentionList, queryString); 
  }

  // -------------------------------------------------------------------- SIDEMENU / NOTIFICATIONS
  
  public GetEventNotificationList(LiveFlag:boolean) // , ignoreLiveFlag:boolean
  :Promise<{}>
  {
    let queryString = this.commonProvider.GetQsLiveEventsFilter(LiveFlag, this.isEncodeComponent);

    // Note: since we are using AmbitMessage for EventNotifications, we want to get the LiveFlag from the Event instead
    //if (ignoreLiveFlag === false)
    //{
    //  queryString = this.commonProvider.GetQsBooleanFilter(LiveFlag, this.isEncodeComponent
    //  , "EventLiveFlag");  
    //}
    return this.CallAmbitMobileApiGet(this.apiName.GetEventNotificationList, queryString); 
  }

  // -------------------------------------------------------------------- SIDEMENU / Monitor
  
  public GetMonitor(MobileMonitorId:number):Promise<{}>
  {
    let queryString = "&MobileMonitorId=" + MobileMonitorId;
    return this.CallAmbitMobileApiGet(this.apiName.GetMonitor, queryString); 
  } 

  public AssignMonitor(MobileMonitorId:number, StatusText:string, AssignedMobileUserId:number
                     , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileMonitorId=" + MobileMonitorId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&AssignedMobileUserId=" + AssignedMobileUserId
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.AssignMonitor, queryString); 
  } 

  public UnassignMonitor(MobileMonitorId:number, StatusText:string
                       , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileMonitorId=" + MobileMonitorId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UnassignMonitor, queryString); 
  } 

  public UpdateMonitor(MobileMonitorId:number, StatusText:string):Promise<{}>
  {
      alert("ToDo: UpdateMonitor not implemented in API yet");
    let queryString = "&MobileMonitorId=" + MobileMonitorId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UpdateMonitor, queryString); 
  }

  public ForceCloseMonitor(MobileMonitorId:number, StatusText:string):Promise<{}>
  {
      alert("ToDo: ForceCloseMonitor not implemented in API yet");
    let queryString = "&MobileMonitorId=" + MobileMonitorId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ForceCloseMonitor, queryString); 
  }

  // -------------------------------------------------------------------- SIDEMENU / REPORT
  
  public GetReport(MobileReportId:number):Promise<{}>
  {
    let queryString = "&MobileReportId=" + MobileReportId;
    return this.CallAmbitMobileApiGet(this.apiName.GetReport, queryString); 
  } 

  public AssignReport(MobileReportId:number, StatusText:string, AssignedMobileUserId:number
                     , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileReportId=" + MobileReportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&AssignedMobileUserId=" + AssignedMobileUserId
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.AssignReport, queryString); 
  } 

  public UnassignReport(MobileReportId:number, StatusText:string
                       , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileReportId=" + MobileReportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UnassignReport, queryString); 
  } 

  public UpdateReport(MobileReportId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileReportId=" + MobileReportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UpdateReport, queryString); 
  }

  public CloseReport(MobileReportId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileReportId=" + MobileReportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.CloseReport, queryString); 
  }

  public ReopenReport(MobileReportId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileReportId=" + MobileReportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ReopenReport, queryString);  // NOTE: using the UPDATE function for now
  }

  // -------------------------------------------------------------------- SIDEMENU / SUPPORT
  
  public GetSupport(MobileSupportId:number):Promise<{}>
  {
    let queryString = "&MobileSupportId=" + MobileSupportId;
    return this.CallAmbitMobileApiGet(this.apiName.GetSupport, queryString); 
  } 

  public AssignSupport(MobileSupportId:number, StatusText:string, AssignedMobileUserId:number
                     , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileSupportId=" + MobileSupportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&AssignedMobileUserId=" + AssignedMobileUserId
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.AssignSupport, queryString); 
  } 

  public UnassignSupport(MobileSupportId:number, StatusText:string
                       , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileSupportId=" + MobileSupportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UnassignSupport, queryString); 
  } 

  public UpdateSupport(MobileSupportId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileSupportId=" + MobileSupportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UpdateSupport, queryString); 
  }

  public CloseSupport(MobileSupportId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileSupportId=" + MobileSupportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.CloseSupport, queryString); 
  }

  public ReopenSupport(MobileSupportId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileSupportId=" + MobileSupportId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ReopenSupport, queryString);  // NOTE: using the UPDATE function for now
  }

  // -------------------------------------------------------------------- SIDEMENU / CONFIDENTIAL
  // NOTE:  THESE MAY NOT APPLY TO THIS FEATURE DUE TO THE NATURE OF BEING CONFIDENTIAL BUT COPIED HERE FOR NOW
  
  public GetConfidential(MobileConfidentialId:number):Promise<{}>
  {
    let queryString = "&MobileConfidentialId=" + MobileConfidentialId;
    return this.CallAmbitMobileApiGet(this.apiName.GetConfidential, queryString); 
  } 

  public AssignConfidential(MobileConfidentialId:number, StatusText:string, AssignedMobileUserId:number
                     , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileConfidentialId=" + MobileConfidentialId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&AssignedMobileUserId=" + AssignedMobileUserId
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.AssignConfidential, queryString); 
  } 

  public UnassignConfidential(MobileConfidentialId:number, StatusText:string
                       , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileConfidentialId=" + MobileConfidentialId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UnassignConfidential, queryString); 
  } 

  public UpdateConfidential(MobileConfidentialId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileConfidentialId=" + MobileConfidentialId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UpdateConfidential, queryString); 
  }

  public CloseConfidential(MobileConfidentialId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileConfidentialId=" + MobileConfidentialId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.CloseConfidential, queryString); 
  }

  public ReopenConfidential(MobileConfidentialId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileConfidentialId=" + MobileConfidentialId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ReopenConfidential, queryString);  // NOTE: using the UPDATE function for now
  }

  // -------------------------------------------------------------------- SIDEMENU / ANONYMOUS
  // NOTE:  THESE MAY NOT APPLY TO THIS FEATURE DUE TO THE NATURE OF BEING ANONYMOUS BUT COPIED HERE FOR NOW
  
  public GetAnonymous(MobileAnonymousId:number):Promise<{}>
  {
    let queryString = "&MobileAnonymousId=" + MobileAnonymousId;
    return this.CallAmbitMobileApiGet(this.apiName.GetAnonymous, queryString); 
  } 

  public AssignAnonymous(MobileAnonymousId:number, StatusText:string, AssignedMobileUserId:number
                     , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileAnonymousId=" + MobileAnonymousId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&AssignedMobileUserId=" + AssignedMobileUserId
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.AssignAnonymous, queryString); 
  } 

  public UnassignAnonymous(MobileAnonymousId:number, StatusText:string
                       , LastDbDatetimeUtc:string, LastUpdateApiLogId:number ):Promise<{}>
  {
    let queryString = "&MobileAnonymousId=" + MobileAnonymousId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    + "&LastDbDatetimeUtc=" + LastDbDatetimeUtc
                    + "&LastUpdateApiLogId=" + LastUpdateApiLogId
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UnassignAnonymous, queryString); 
  } 

  public UpdateAnonymous(MobileAnonymousId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileAnonymousId=" + MobileAnonymousId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UpdateAnonymous, queryString); 
  }

  public CloseAnonymous(MobileAnonymousId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileAnonymousId=" + MobileAnonymousId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.CloseAnonymous, queryString); 
  }

  public ReopenAnonymous(MobileAnonymousId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&MobileAnonymousId=" + MobileAnonymousId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ReopenAnonymous, queryString);  // NOTE: using the UPDATE function for now
  }

  // -------------------------------------------------------------------- QUESTIONNAIRE FORM

  public RequestForQuestionnaire( QuestionnaireFormId:number ):Promise<{}>
  {
    // https://ambit.maxxess-systems.com/AmbitMobileApi/api/mobile/
    // RequestForQuestionnaire
    // ?QuestionnaireFormId=14134

    let queryString = "&QuestionnaireFormId=" + QuestionnaireFormId 
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RequestForQuestionnaire, queryString); 
  }
  
  public ResponseToQuestionnaire( QuestionnaireFormId
                                , ResponseIdListYes
                                , ResponseIdListNo
                                , TriggeredByStructuredFormId
                                , TriggeredByStructuredResponseId
                                , EventId
                                , ContextFeatureId:number     // e.g. 4 for "CHECKIN"
                                , ContextName:string          // "MobileCheckinId", "MobileSupportId", "MobileReportId"
                                , ContextId:string            // the value of MobileCheckinId, etc.
                                , qsResponseIds   // this is a straight querystring (redundant info but may prove useful)
                                , UserResponseText
                                ):Promise<{}>
  {
    let queryString = "&QuestionnaireFormId=" + QuestionnaireFormId
                    + "&ResponseIdListYes=" + ResponseIdListYes
                    + "&ResponseIdListNo=" + ResponseIdListNo
                    + "&TriggeredByStructuredFormId=" + TriggeredByStructuredFormId
                    + "&TriggeredByStructuredResponseId=" + TriggeredByStructuredResponseId
                    + "&EventId=" + EventId
                    + "&ContextFeatureId=" + ContextFeatureId
                    + "&" + ContextName + "=" + ContextId
                    + qsResponseIds
                    + ( (UserResponseText) ? ("&UserResponseText=" + this.DoEncodeComponent(UserResponseText)) : ("") ) 
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToQuestionnaire, queryString); 
  } 

  // -------------------------------------------------------------------- SIDEMENU / ATTENTION SURVEY

  public RequestForSystemSurveyForm( SurveyBroadcastId:number ):Promise<{}>
  {
    let queryString = "&SurveyBroadcastId=" + SurveyBroadcastId //StructuredMessageBroadcastId
                    ;
    // ToDo:  move this code into the survey response for when the call is completed successfully:
    this.globalProvider.SetStorageObject_LatestSurvey(SurveyBroadcastId, 0, "REQUESTED"); //(data:any)
    // ToDo:  move this code into the survey response for when the call is completed successfully:

    return this.CallAmbitMobileApiGet(this.apiName.RequestForSystemSurveyForm, queryString); 
  }

  public ResponseToSystemSurveyForm( SurveyBroadcastId:number
                                   , SurveyRecipientId:number
                                   , StructuredResponseId:number
                                   , UserResponseText:string
                                   , EventSiteId:number):Promise<{}> 
  {
    let queryString = "&SurveyBroadcastId=" + SurveyBroadcastId
                    + "&SurveyRecipientId=" + SurveyRecipientId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + ( (EventSiteId > 0) ? ("&EventSiteId=" + EventSiteId) : ("") ) 
                    + "&UserResponseText=" + this.DoEncodeComponent(UserResponseText)
                    ;

    // ToDo:  move this code into the survey response for when the call is completed successfully:
    this.globalProvider.SetStorageObject_LatestSurvey(SurveyBroadcastId, SurveyRecipientId, "RESPONDED"); //(data:any)
    // ToDo:  move this code into the survey response for when the call is completed successfully:
  
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToSystemSurveyForm, queryString); 
  }

  public ReceivedNotificationForSystemSurvey( SurveyBroadcastId:number, SurveyRecipientId:number):Promise<{}> 
  {
    let queryString = "&SurveyRecipientId=" + SurveyRecipientId;

    // ToDo:  move this code into the survey response for when the call is completed successfully:
    this.globalProvider.SetStorageObject_LatestSurvey(SurveyBroadcastId, SurveyRecipientId, "NOTIFIED"); //(data:any)
    // ToDo:  move this code into the survey response for when the call is completed successfully:
  
    return this.CallAmbitMobileApiGet(this.apiName.ReceivedNotificationForSystemSurvey, queryString); 
  }

  // -------------------------------------------------------------------- ACTIONABLE FORM

  public RequestForActionableForm( ActionableBroadcastId:number ):Promise<{}>
  {
    let queryString = "&SurveyBroadcastId=" + ActionableBroadcastId // StructuredMessageBroadcastId
                    //+ "&SurveyRecipientId=" + ActionableRecipientId // StructuredMessageRecipientId
                    + "&ActionableBroadcastId=" + ActionableBroadcastId // StructuredMessageBroadcastId
                    //+ "&ActionableRecipientId=" + ActionableRecipientId // StructuredMessageRecipientId
                    ;
                    
    // ToDo:  move this code into the survey response for when the call is completed successfully:
    this.globalProvider.SetStorageObject_LatestActionableForm(ActionableBroadcastId, 0, "REQUESTED"); //(data:any)
    // ToDo:  move this code into the survey response for when the call is completed successfully:

    return this.CallAmbitMobileApiGet(this.apiName.RequestForActionableForm, queryString); 
  }

  public ResponseToActionableForm( ActionableBroadcastId:number, ActionableRecipientId:number
    , StructuredResponseId:number, UserResponseText:string):Promise<{}>
  {
    let queryString = "&SurveyBroadcastId=" + ActionableBroadcastId
                    + "&SurveyRecipientId=" + ActionableRecipientId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + "&UserResponseText=" + this.DoEncodeComponent(UserResponseText)
                    ;

    // ToDo:  move this code into the survey response for when the call is completed successfully:
    this.globalProvider.SetStorageObject_LatestActionableForm(ActionableBroadcastId, ActionableRecipientId, "RESPONDED"); //(data:any)
    // ToDo:  move this code into the survey response for when the call is completed successfully:
  
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToActionableForm, queryString); 
  }

  public ReceivedNotificationForActionableForm( ActionableBroadcastId:number, ActionableRecipientId:number):Promise<{}> 
  {
    let queryString = "&SurveyRecipientId=" + ActionableRecipientId
                    + "&ActionableRecipientId=" + ActionableRecipientId;

    // ToDo:  move this code into the survey response for when the call is completed successfully:
    this.globalProvider.SetStorageObject_LatestSurvey(ActionableBroadcastId, ActionableRecipientId, "NOTIFIED"); //(data:any)
    // ToDo:  move this code into the survey response for when the call is completed successfully:
  
    return this.CallAmbitMobileApiGet(this.apiName.ReceivedNotificationForActionableForm, queryString); 
  }
  // -------------------------------------------------------------------- SIDEMENU / BROADCASTED SURVEY
  
  public GetSurveyBroadcasted(SurveyBroadcastId:number):Promise<{}>
  {
    let queryString = "&SurveyBroadcastId=" + SurveyBroadcastId;
    return this.CallAmbitMobileApiGet(this.apiName.GetSurveyBroadcasted, queryString); 
  } 

  public GetSurveyResponseSummary(SurveyBroadcastId:number):Promise<{}>
  {
    let queryString = "&SurveyBroadcastId=" + SurveyBroadcastId;
    return this.CallAmbitMobileApiGet(this.apiName.GetSurveyResponseSummary, queryString); 
  } 

  public ResubmitPendingRecipients(SurveyBroadcastId:number):Promise<{}>
  {
    let queryString = "&SurveyBroadcastId=" + SurveyBroadcastId;
    return this.CallAmbitMobileApiGet(this.apiName.ResubmitPendingRecipients, queryString); 
  } 

  public MobileCloseSurvey(SurveyBroadcastId:number):Promise<{}>
  {
    let queryString = "&SurveyBroadcastId=" + SurveyBroadcastId;
    return this.CallAmbitMobileApiGet(this.apiName.MobileCloseSurvey, queryString); 
  } 

  public MobileReopenSurvey(SurveyBroadcastId:number):Promise<{}>
  {
    let queryString = "&SurveyBroadcastId=" + SurveyBroadcastId;
    return this.CallAmbitMobileApiGet(this.apiName.MobileReopenSurvey, queryString); 
  } 
  
  
  
  // -------------------------------------------------------------------- ACTIONS / MONITOR
  
  public SendMobileMonitorStatus( MobileMonitorId
                                , MobileMonitorTypeCode
                                , SessionCode
                                , SessionCounter
                                , MobileUserMessageText:string
                                , EventSiteId:number
                                ):Promise<{}>
  {
    let queryString = "&MobileMonitorId=" + MobileMonitorId
                    + "&MobileMonitorTypeCode=" + MobileMonitorTypeCode
                    + "&SessionCode=" + SessionCode
                    + "&SessionCounter=" + SessionCounter
                    + "&MessageText=" + this.DoEncodeComponent(MobileUserMessageText)
                    + ( (EventSiteId > 0) ? ("&EventSiteId=" + EventSiteId) : ("") ) 
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.SendMobileMonitorStatus, queryString); 
  }

  public GetStatusForMobileMonitor():Promise<{}>
  {
    let queryString = "";
    return this.CallAmbitMobileApiGet(this.apiName.GetStatusForMobileMonitor, queryString); 
  }

  // -------------------------------------------------------------------- ACTIONS / REPORT
  
  public RequestForMobileReportForm():Promise<{}>
  {
    let queryString = "&MobileSupportId=" + 0
                    + "&MobileSupportTypeCode=" + "REPORT"   // required
                    + "&StructuredFormTypeCode=" + "REPORT"  // optional
                    //+ "&MobileSupportSessionTypeCode=" + "FORM_REQUEST"
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RequestForMobileReportForm, queryString); 
  } 
  
  public ResponseToMobileReportForm( EventGuid 
                                   , MobileReportId 
                                   , StructuredResponseId
                                   , UserResponseText
                                   , EventSiteId:number
                                   ):Promise<{}>
  {
    let queryString = "&EventGuid=" + EventGuid
                    + "&MobileSupportId=" + MobileReportId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + ( (EventSiteId > 0) ? ("&EventSiteId=" + EventSiteId) : ("") ) 
                    + "&UserResponseText=" + this.DoEncodeComponent(UserResponseText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToMobileReportForm, queryString); 
  } 

  // -------------------------------------------------------------------- ACTIONS / CONFIDENTIAL
  
  public RequestForMobileConfidentialForm():Promise<{}>
  {
    let queryString = "&MobileSupportId=" + 0
                    + "&MobileSupportTypeCode=" + "REPORT"   // required
                    + "&StructuredFormTypeCode=" + "CONFIDENTIAL"  // optional
                    //+ "&MobileSupportSessionTypeCode=" + "FORM_REQUEST"
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RequestForMobileConfidentialForm, queryString); 
  } 
  
  public ResponseToMobileConfidentialForm( EventGuid 
                                   , MobileReportId 
                                   , StructuredResponseId
                                   , UserResponseText
                                   , EventSiteId:number
                                   ):Promise<{}>
  {
    let queryString = "&EventGuid=" + EventGuid
                    + "&MobileSupportId=" + MobileReportId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + ( (EventSiteId > 0) ? ("&EventSiteId=" + EventSiteId) : ("") ) 
                    + "&UserResponseText=" + this.DoEncodeComponent(UserResponseText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToMobileConfidentialForm, queryString); 
  } 

  // -------------------------------------------------------------------- ACTIONS / ANONYMOUS
  
  public RequestForMobileAnonymousForm():Promise<{}>
  {
    let queryString = "&MobileSupportId=" + 0
                    + "&MobileSupportTypeCode=" + "REPORT"   // required
                    + "&StructuredFormTypeCode=" + "ANONYMOUS"  // optional
                    //+ "&MobileSupportSessionTypeCode=" + "FORM_REQUEST"
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RequestForMobileAnonymousForm, queryString); 
  } 
  
  public ResponseToMobileAnonymousForm( EventGuid 
                                   , MobileReportId 
                                   , StructuredResponseId
                                   , UserResponseText
                                   , EventSiteId:number
                                   ):Promise<{}>
  {
    let queryString = "&EventGuid=" + EventGuid
                    + "&MobileSupportId=" + MobileReportId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + ( (EventSiteId > 0) ? ("&EventSiteId=" + EventSiteId) : ("") ) 
                    + "&UserResponseText=" + this.DoEncodeComponent(UserResponseText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToMobileAnonymousForm, queryString); 
  } 

  // -------------------------------------------------------------------- ACTIONS / ACCESS
  
  public RequestForMobileAccessForm():Promise<{}>
  {
    let queryString = "&MobileSupportId=" + 0
                    + "&MobileSupportTypeCode=" + "ACCESS"   // required
                    + "&StructuredFormTypeCode=" + "ACCESS"  // optional
                    //+ "&MobileSupportSessionTypeCode=" + "FORM_REQUEST"
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RequestForMobileAccessForm, queryString); 
  } 
  
  public ResponseToMobileAccessForm( EventGuid 
                                   , MobileAccessId 
                                   , StructuredResponseId
                                   , UserResponseText
                                   , EventSiteId:number
                                   ):Promise<{}>
  {
    let queryString = "&EventGuid=" + EventGuid
                    + "&MobileSupportId=" + MobileAccessId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + ( (EventSiteId > 0) ? ("&EventSiteId=" + EventSiteId) : ("") ) 
                    + "&UserResponseText=" + this.DoEncodeComponent(UserResponseText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToMobileAccessForm, queryString); 
  } 

  // -------------------------------------------------------------------- ACTIONS / REPORT
  
  public RequestForMobileDoorControlForm(MxUsername:string, MxPassword:string):Promise<{}>
  {
    let queryString = "&MobileSupportId=" + 0
                    + "&MobileSupportTypeCode=" + "DOOR_CONTROL"   // required
                    + "&StructuredFormTypeCode=" + "DOOR_CONTROL"  // optional
                    + "&MxUsername=" + MxUsername
                    + "&MxPassword=" + MxPassword
                    //+ "&MobileSupportSessionTypeCode=" + "FORM_REQUEST"
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RequestForMobileDoorControlForm, queryString); 
  } 
  
  public ResponseToMobileDoorControlForm( EventGuid 
                                   , MobileAccessId 
                                   , StructuredResponseId
                                   , UserResponseText
                                   , EventSiteId:number
                                   , MxDoorId
                                   , MxDoorCommandId:string
                                   , MxDoorCommandTypeCode:string
                                   , MxDoorGroupFlag:boolean
                                   , MxUsername:string, MxPassword:string
                                   , MobilePassword
                                   ):Promise<{}>
  {
    let queryString = "&EventGuid=" + EventGuid
                    + "&MobileSupportId=" + MobileAccessId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + ( (EventSiteId > 0) ? ("&EventSiteId=" + EventSiteId) : ("") ) 
                    + "&UserResponseText=" + this.DoEncodeComponent(UserResponseText)
                    + "&MxDoorId=" + MxDoorId
                    + "&MxDoorCommandId=" + MxDoorCommandId
                    + "&MxDoorCommandTypeCode=" + MxDoorCommandTypeCode
                    + "&MxDoorGroupFlag=" + MxDoorGroupFlag
                    + "&MxUsername=" + this.DoEncodeComponent(MxUsername)
                    + "&MxPassword=" + this.DoEncodeComponent(MxPassword)
                    + "&MobilePassword=" + this.DoEncodeComponent(MobilePassword)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToMobileDoorControlForm, queryString); 
  } 

  // -------------------------------------------------------------------- ACTIONS / CHECKIN
  
  public GetStatusForMobileCheckin():Promise<{}>
  {
    let queryString = "";
    return this.CallAmbitMobileApiGet(this.apiName.GetStatusForMobileCheckin, queryString); 
  } 
  public GetStatusForMobileCheckin_DASHBOARD():Promise<{}>
  {
    let queryString = "";
    return this.CallAmbitMobileApiGet(this.apiName.GetStatusForMobileCheckin_DASHBOARD, queryString); 
  } 

  public UpdateStatusForMobileCheckin( StructuredFormId
                                     , StructuredResponseId 
                                     , WorkStatusCode
                                     , MobileCheckinTypeCode
                                     , MobileCheckinSessionTypeCode
                                     , CommentsText
                                     , LocationChoiceTypeCode
                                     , EventSiteId
                                     , QuestionnaireFormId
                                     ):Promise<{}>
  {
    let queryString = "&StructuredFormId=" + StructuredFormId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + "&WorkStatusCode=" + WorkStatusCode
                    + "&MobileCheckinTypeCode=" + MobileCheckinTypeCode
                    + "&MobileCheckinSessionTypeCode=" + MobileCheckinSessionTypeCode    
                    + "&CommentsText=" + this.DoEncodeComponent(CommentsText)   
                    + "&UserResponseText=" + this.DoEncodeComponent(CommentsText)
                    + "&LocationChoiceTypeCode=" + LocationChoiceTypeCode 
                    + "&EventSiteId=" + EventSiteId     // the checkin site location
                    + "&SiteLocationId=" + EventSiteId  // same as above
                    + "&QuestionnaireFormId=" + QuestionnaireFormId // FYI only
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.UpdateStatusForMobileCheckin, queryString); 
  } 
  
  // -------------------------------------------------------------------- ACTIONS / SUPPORT
  
  public RequestForMobileSupportForm():Promise<{}>
  {
    let queryString = "&MobileSupportId=" + 0
                    + "&MobileSupportTypeCode=" + "SUPPORT"   // required
                    + "&StructuredFormTypeCode=" + "SUPPORT"  // optional
                    //+ "&MobileSupportSessionTypeCode=" + "FORM_REQUEST"
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.RequestForMobileSupportForm, queryString); 
  } 
  
  public ResponseToMobileSupportForm( EventGuid 
                                    , MobileSupportId 
                                    , StructuredResponseId
                                    , UserResponseText
                                    , EventSiteId:number
                                    ):Promise<{}>
  {
    let queryString = "&EventGuid=" + EventGuid
                    + "&MobileSupportId=" + MobileSupportId
                    + "&StructuredResponseId=" + StructuredResponseId
                    + ( (EventSiteId > 0) ? ("&EventSiteId=" + EventSiteId) : ("") ) 
                    + "&UserResponseText=" + this.DoEncodeComponent(UserResponseText)
                    ;
    return this.CallAmbitMobileApiGet(this.apiName.ResponseToMobileSupportForm, queryString); 
  } 

  // -------------------------------------------------------------------- ACTIONS / SURVEY
  
  public GetSurveyFormList():Promise<{}>
  {
    let queryString = "&Filter=" + "AmbitFeatureId|EQ|5"                // surveys only (redundant)
                    + "&Filter=" + "StructuredFormStatusTypeId|EQ|1"    // active forms only
    ;
    return this.CallAmbitMobileApiGet(this.apiName.GetSurveyFormList, queryString); 
  } 

  public MobileBroadcastSurvey( StructuredFormId
                              , AppendMessageText
                              , SurveyTargetTypeCode
                              , SurveyTargetList
                              , PriorityFlag
                              , MobileMediaId    // Broadcast Survey related
                              , MobileMediaIdList
                              ):Promise<{}>
  {
    let queryString = "&StructuredFormId=" + StructuredFormId
    + "&AppendMessageText=" + this.DoEncodeComponent(AppendMessageText)
    + "&SurveyTargetTypeCode=" + SurveyTargetTypeCode
    + "&PriorityFlag=" + PriorityFlag
    + ((MobileMediaId !== 0)? ("&MobileMediaId=" + MobileMediaId) : "")
    + ((MobileMediaIdList)? ("&MobileMediaIdList=" + MobileMediaIdList) : "")
    // Note that only one type of "SurveyTargetTypeCode" is really supported, so we only expect one of the following:
    // ALL | SITES | DEPARTMENTS | MOBILEUSERS
    // It is written out inline however for ease of readability only;  maybe later support can be added for a combination
    + ((SurveyTargetTypeCode === "ALL")? "" : "")
    + ((SurveyTargetTypeCode === "SITES")? ("&SiteIdList=" + SurveyTargetList) : "")
    + ((SurveyTargetTypeCode === "DEPARTMENTS")? ("&DepartmentIdList=" + SurveyTargetList) : "")
    + ((SurveyTargetTypeCode === "MOBILEUSERS")? ("&MobileUserIdList=" + SurveyTargetList) : "")
    ;

    // console.log("API.MobileBroadcastSurvey - " + queryString);
    return this.CallAmbitMobileApiGet(this.apiName.MobileBroadcastSurvey, queryString); 
  } 

  // -------------------------------------------------------------------- ACTIONS / general (CHECKIN, SURVEY)

  public GetSiteInfo(SiteId:number):Promise<{}>
  {
    let queryString = "&Filter=" + "SiteId|EQ|" + SiteId;
    return this.CallAmbitMobileApiGet(this.apiName.GetSiteInfoList, queryString); 

    //let queryString = "&SiteId=" + SiteId;
    //return this.CallAmbitMobileApiGet(this.apiName.GetSiteInfo, queryString); 
  } 

  public GetSiteInfoList(ignoreEmptySiteFlag:boolean):Promise<{}>
  {
    let queryString = ""
                    + (ignoreEmptySiteFlag)? "" : ("&Filter=" + "MobileUsersActiveCount|GT|0");
    return this.CallAmbitMobileApiGet(this.apiName.GetSiteInfoList, queryString); 
  } 

  public GetDepartmentInfoList(ignoreEmptyDepartmentFlag:boolean):Promise<{}>
  {
    let queryString = ""
                    + (ignoreEmptyDepartmentFlag)? ("&Filter=" + "MobileUsersActiveCount|GT|0") : "";
    return this.CallAmbitMobileApiGet(this.apiName.GetDepartmentInfoList, queryString); 
  }

  // -------------------------------------------------------------------- AMBIT MESSAGE (Feature 19)

  public SendAmbitMessageAsPushToSelf(MessageText:string):Promise<{}>
  {
    let queryString = "&MessageText=" + this.DoEncodeComponent(MessageText);
    return this.CallAmbitMobileApiGet(this.apiName.SendAmbitMessageAsPushToSelf, queryString); 
  }
  public SendAmbitMessageAsEmailToSelf(MessageText:string):Promise<{}>
  {
    let queryString = "&MessageText=" + this.DoEncodeComponent(MessageText);
    return this.CallAmbitMobileApiGet(this.apiName.SendAmbitMessageAsEmailToSelf, queryString); 
  }
  public SendAmbitMessageAsTextToSelf(MessageText:string):Promise<{}>
  {
    let queryString = "&MessageText=" + this.DoEncodeComponent(MessageText);
    return this.CallAmbitMobileApiGet(this.apiName.SendAmbitMessageAsTextToSelf, queryString); 
  }

  public GetAmbitMessageList(LiveFlag:boolean):Promise<{}>
  {
    let queryString = this.commonProvider.GetQsLiveEventsFilter(LiveFlag, this.isEncodeComponent);
    return this.CallAmbitMobileApiGet(this.apiName.GetAmbitMessageList, queryString); 
  }
  public GetAmbitMessage(AmbitMessageId:number):Promise<{}>
  {
    let queryString = "&AmbitMessageId=" + AmbitMessageId;
    return this.CallAmbitMobileApiGet(this.apiName.GetAmbitMessage, queryString); 
  }
  public ReceivedAmbitMessage(AmbitMessageId:number):Promise<{}>
  {
    let queryString = "&AmbitMessageId=" + AmbitMessageId;
    return this.CallAmbitMobileApiGet(this.apiName.ReceivedAmbitMessage, queryString); 
  }
  public UpdateAmbitMessage(AmbitMessageId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&AmbitMessageId=" + AmbitMessageId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
    return this.CallAmbitMobileApiGet(this.apiName.UpdateAmbitMessage, queryString); 
  }
  public CloseAmbitMessage(AmbitMessageId:number, StatusText:string):Promise<{}>
  {
    let queryString = "&AmbitMessageId=" + AmbitMessageId
                    + "&StatusText=" + this.DoEncodeComponent(StatusText)
    return this.CallAmbitMobileApiGet(this.apiName.CloseAmbitMessage, queryString); 
  }

  // NotificationReceived
  public ReceivedNotificationForAmbitMessage(AmbitEventTypeCode:string, NotificationTypeCode:string
  , AmbitMessageId:number, EventId:number, AbstractId:number):Promise<{}>
  {
    let queryString = "&notification=" + "RECEIVED" // this.DoEncodeComponent(notificationString)
                    + "&AmbitMessageId=" + AmbitMessageId
                    + "&EventId=" + EventId
                    + "&AbstractId=" + AbstractId
                    + "&AmbitEventTypeCode=" + AmbitEventTypeCode
                    + "&NotificationTypeCode=" + NotificationTypeCode   // same as AmbitEventTypeCode but distinguishes Actionable
                    ;

    // ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- 
    // NOTE: using "TestDatabaseQueryTime" for now until we can switch to specific function
    return this.CallAmbitMobileApiGet(this.apiName.TestDatabaseQueryTime, queryString); 
    // NOTE: using "TestDatabaseQueryTime" for now until we can switch to specific function
    // ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- ToDo -- 
  }
  
  // -------------------------------------------------------------------- ACTIONS / MEDiA
  
  public UploadMediaFile_Base64Data( ContextFeatureId
                                   , ContextFeatureName:string
                                   , ContextId
                                   , ContextName:string
                                   , UploadBase64Data:any
                                   , UploadBase64DataString:string
                                   , FileType:string
                                   ):Promise<{}>
  {
    console.log("UploadMediaFile_Base64Data");

    let FileNameOriginal = "NewPicture.jpg"; // || file.fileName;
    let FileNameAmbit = this.commonProvider.GenerateNewUploadFileName(FileNameOriginal, ContextId);
    let FileSize = UploadBase64Data.length; // REQUIRED BY API // SelectedFile.size
    console.log("UploadMediaFile_Base64Data: " + FileNameOriginal + " Size:" + FileSize + " Type:" + FileType + " AmbitName:" + FileNameAmbit);

    let queryString = "&ContextFeatureId=" + ContextFeatureId       // "7"
                    + "&ContextFeatureName=" + this.DoEncodeComponent(ContextFeatureName)   // "MEDIA"
                    + "&" + ContextName + "=" + ContextId           // "MobileMonitorId=38778"
                    + "&FileSize=" + FileSize
                    + "&FileType=" + this.DoEncodeComponent(FileType)
                    + "&FileNameOriginal=" + FileNameOriginal
                    + "&FileNameAmbit=" + FileNameAmbit
                    + "&Base64Ind=TRUE"  // TRUE|FALSE <<<<< very important for Cordova File
                    + "&IgnoreMediaLengthErrorInd=" + "TRUE" // until we can figure out why the values are different despite it working
                    ;

    return this.CallAmbitMobileApiPostBase64Data(this.apiName.UploadMediaFile, queryString
    , UploadBase64Data, UploadBase64DataString
    , ContextFeatureId, ContextFeatureName, ContextName, ContextId, FileNameOriginal, FileNameAmbit, FileSize.toString()
    );
  }

  public UploadMediaFile_AsFile( ContextFeatureId
                               , ContextFeatureName:string
                               , ContextId
                               , ContextName:string
                               , UploadFile:File
                               ):Promise<{}>
  {
    console.log("UploadMediaFile_AsFile");

    let FileNameOriginal = UploadFile.name; // || file.fileName;
    let FileNameAmbit = this.commonProvider.GenerateNewUploadFileName(FileNameOriginal, ContextId);
    let FileSize = UploadFile.size;
    let FileType = UploadFile.type;
    console.log("UploadMediaFile_AsFile: " + FileNameOriginal + " Size:" + FileSize + " Type:" + FileType + " AmbitName:" + FileNameAmbit);

    let queryString = "&ContextFeatureId=" + ContextFeatureId       // "7"
                    + "&ContextFeatureName=" + this.DoEncodeComponent(ContextFeatureName)   // "MEDIA"
                    + "&" + ContextName + "=" + ContextId           // "MobileMonitorId=38778"
                    + "&FileSize=" + FileSize
                    + "&FileType=" + this.DoEncodeComponent(FileType)
                    + "&FileNameOriginal=" + FileNameOriginal
                    + "&FileNameAmbit=" + FileNameAmbit
                    + "&Base64Ind=FALSE"    // TRUE|FALSE <<<<< very important for Cordova File
                    ;

    // HEADERS -- still needed?
    // http://www.html5rocks.com/en/tutorials/cors/  -- the 'not so simple' method
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS
    // http://stackoverflow.com/questions/5686059/how-to-avoid-cross-domain-policy-in-jquery-ajax-for-consuming-wcf-service
    
    // USE THIS -- we need to stick with SYNCHRONOUS call as that is all the API supportd right now
    let headers = new HttpHeaders(
      { 'X-FunctionName':       'UploadMediaFile'
      , 'X-ContextFeatureId':   ContextFeatureId
      , 'X-ContextFeatureName': ContextFeatureName
      , 'X-ContextName':        ContextName
      , 'X-ContextId':          ContextId
      , 'X-File-NameOriginal':  FileNameOriginal
      , 'X-File-Name':          FileNameAmbit
      , 'X-File-Size':          FileSize.toString()
      , 'Access-Control-Allow-Origin': '*'
      , 'Content-Type':         'multipart/form-data' 
      , 'Cache-Control':        'no-cache'
      //, 'Authorization': this.basic 
      }
    );
    let options = { headers: headers };
    return this.CallAmbitMobileApiPostFile(this.apiName.UploadMediaFile, queryString, UploadFile, options);
  } 

  public UploadMediaFile_FormData( ContextFeatureId
                                 , ContextFeatureName:string
                                 , ContextId
                                 , ContextName:string
                                 , SelectedFile:File
                                ):Promise<{}> 
  {
    // NOTE BEING USED NOW -- CONSIDER LATER FOR MULTIPLE FILE SUBMISSION
    // REQUIRES CHANGES IN THE AMBIT SERVER API TO SUPPORT ASYNCHRONOUS CALL (Task / Await etc)
    console.log("UploadMediaFile_FormData");

    let FileNameOriginal = SelectedFile.name; // || file.fileName;
    let FileNameAmbit = this.commonProvider.GenerateNewUploadFileName(FileNameOriginal, ContextId);
    let FileSize = SelectedFile.size;
    let FileType = SelectedFile.type;
    console.log("UploadMediaFile: " + FileNameOriginal + " Size:" + FileSize + " Type:" + FileType + " AmbitName:" + FileNameAmbit);

    let queryString = "&ContextFeatureId=" + ContextFeatureId       // "7"
    + "&ContextFeatureName=" + ContextFeatureName   // "MEDIA"
    + "&" + ContextName + "=" + ContextId           // "MobileMonitorId=38778"
    + "&FileSize=" + FileSize
    + "&FileType=" + this.DoEncodeComponent(FileType)
    + "&FileNameOriginal=" + FileNameOriginal
    + "&FileNameAmbit=" + FileNameAmbit
    + "&Base64Ind=FALSE"    // TRUE|FALSE <<<<< very important for Cordova File
    ;

    let headers = new HttpHeaders(
    { 'X-FunctionName':       'UploadMediaFile'
    , 'X-ContextFeatureId':   ContextFeatureId
    , 'X-ContextFeatureName': ContextFeatureName
    , 'X-ContextName':        ContextName
    , 'X-ContextId':          ContextId
    , 'X-File-NameOriginal':  FileNameOriginal
    , 'X-File-Name':          FileNameAmbit
    , 'X-File-Size':          FileSize.toString()
    , 'Access-Control-Allow-Origin': '*'
    //, 'Content-Type':         'multipart/form-data' // 'application/json'  -- added automatically via FormData?
    //, 'Cache-Control':        'no-cache'
    //, 'Authorization': this.basic 
    }
    );
    let options = { headers: headers };

    /* MULTIPLE PHOTOS/FILES -- later maybe?  requires C# code to have an Async API call
    const files: FileList = target.files;
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
    formData.append('file', files[i]);
    }
    */

    const uploadData = new FormData();
    uploadData.append(FileNameOriginal, SelectedFile, SelectedFile.name);  
    return this.CallAmbitMobileApiPostFormData(this.apiName.UploadMediaFile, queryString, uploadData, options);
  } 


  // -----------------------------------------------------------------------------------
  // -------------------------------------------------------------------- GENERIC/ANY MEDIA
  // DISPLAY MEDIA: SPECIFIC URLS (not the regular API call which has a promise return)
  // -----------------------------------------------------------------------------------
  // -----------------------------------------------------------------------------------

  public GetPersonPicture(MobileUserId:number):string
  {
    let queryString = "&PictureMobileUserId=" + MobileUserId;
    return this.CallAmbitMobileApiGetMedia(this.apiName.GetPersonPicture, queryString); 
  } 

  public GetMediaContent(MobileMediaId:number):string
  {
    let queryString = "&MobileMediaId=" + MobileMediaId;
    return this.CallAmbitMobileApiGetMedia(this.apiName.GetMediaContent, queryString); 
  }
  
  public GetMediaContentForAlternateKey(AbstractName:string, AbstractId:number):string
  {
    let queryString = "&" + AbstractName + "=" + AbstractId
                    + "&Filter=" + AbstractName + "|EQ|" + AbstractId
                    ;
    return this.CallAmbitMobileApiGetMedia(this.apiName.GetMediaContentForAlternateKey, queryString); 
  }


  // WORK CONTACTS

  public GetMobileUserWorkContactList():Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.GetMobileUserWorkContactList, ''); 
  }

  // PERSONAL CONTACTS

  public GetMobileUserPersonalContactList():Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.GetMobileUserPersonalContactList, ''); 
  }

  public GetMobileUserPersonalContact(MobileUserPersonalContactId: number):Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.GetMobileUserPersonalContact, `&MobileUserPersonalContactId=${MobileUserPersonalContactId}`); 
  }

  public AddMobileUserPersonalContact(PersonalContactDisplayName: string, PersonalContactEmailAddress: string, PersonalContactPhoneNumber: string, RelationshipLabel: string, EmergencyFlag: boolean):Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.AddMobileUserPersonalContact, `&PersonalContactDisplayName=${PersonalContactDisplayName}&PersonalContactEmailAddress=${PersonalContactEmailAddress}&PersonalContactPhoneNumber=${PersonalContactPhoneNumber}&RelationshipLabel=${RelationshipLabel}&EmergencyFlag=${EmergencyFlag}`); 
  }

  public UpdateMobileUserPersonalContact(MobileUserPersonalContactId: number, PersonalContactDisplayName: string, PersonalContactEmailAddress: string, PersonalContactPhoneNumber: string, RelationshipLabel: string, EmergencyFlag: boolean):Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.UpdateMobileUserPersonalContact, `&MobileUserPersonalContactId=${MobileUserPersonalContactId}&PersonalContactDisplayName=${PersonalContactDisplayName}&PersonalContactEmailAddress=${PersonalContactEmailAddress}&PersonalContactPhoneNumber=${PersonalContactPhoneNumber}&RelationshipLabel=${RelationshipLabel}&EmergencyFlag=${EmergencyFlag}`); 
  }

  public DeleteMobileUserPersonalContact(MobileUserPersonalContactId: number):Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.DeleteMobileUserPersonalContact, `&MobileUserPersonalContactId=${MobileUserPersonalContactId}`); 
  }

  // EMERGENCY AUTODIAL

  public GetMobileUserEmergencyAutodialList():Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.GetMobileUserEmergencyAutodialList, ''); 
  }

  public GetMobileUserEmergencyAutodial(MobileUserEmergencyAutodialId: number):Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.GetMobileUserEmergencyAutodial, `&MobileUserEmergencyAutodialId=${MobileUserEmergencyAutodialId}`); 
  }

  public AddMobileUserEmergencyAutodial(EmergencyAutodialDisplayName: string, EmergencyAutodialEmailAddress: string, EmergencyAutodialPhoneNumber: string, RelationshipLabel: string, EmergencyFlag: boolean):Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.AddMobileUserEmergencyAutodial, `&EmergencyAutodialDisplayName=${EmergencyAutodialDisplayName}&EmergencyAutodialEmailAddress=${EmergencyAutodialEmailAddress}&EmergencyAutodialPhoneNumber=${EmergencyAutodialPhoneNumber}&RelationshipLabel=${RelationshipLabel}&EmergencyFlag=${EmergencyFlag}`); 
  }

  public UpdateMobileUserEmergencyAutodial(MobileUserEmergencyAutodialId: number, EmergencyAutodialDisplayName: string, EmergencyAutodialEmailAddress: string, EmergencyAutodialPhoneNumber: string, RelationshipLabel: string, EmergencyFlag: boolean):Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.UpdateMobileUserEmergencyAutodial, `&MobileUserEmergencyAutodialId=${MobileUserEmergencyAutodialId}&EmergencyAutodialDisplayName=${EmergencyAutodialDisplayName}&EmergencyAutodialEmailAddress=${EmergencyAutodialEmailAddress}&EmergencyAutodialPhoneNumber=${EmergencyAutodialPhoneNumber}&RelationshipLabel=${RelationshipLabel}&EmergencyFlag=${EmergencyFlag}`); 
  }

  public DeleteMobileUserEmergencyAutodial(MobileUserEmergencyAutodialId: number):Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.DeleteMobileUserEmergencyAutodial, `&MobileUserEmergencyAutodialId=${MobileUserEmergencyAutodialId}`); 
  }

  public SetActiveMobileUserEmergencyAutodial():Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.SetActiveMobileUserEmergencyAutodial, ''); 
  }

  public SetInactiveMobileUserEmergencyAutodial():Promise<{ }>
  {
    return this.CallAmbitMobileApiGet(this.apiName.SetInactiveMobileUserEmergencyAutodial, ''); 
  }


  // -----------------------------------------------------------------------------------
  // -------------------------- GENERIC INFO FOR ALL API CALLS -------------------------
  // -----------------------------------------------------------------------------------

  public GetPushInformation(functionName:string):string
  {
    if (functionName === 'RegisterMobileForPush')
    {
      // this function already handles these two values, so it causes a duplicate QueryString issue
      // if we include it again
      return "";
    }

    // include native device values (even if empty as with mobile web app, since AmbitMobileLogin requires it)
    let PushType:string = this.globalProvider.PushConfig.DevicePushRegType;
    let PushUrl:string = this.globalProvider.PushConfig.DevicePushRegId;

    // include native device values (even if empty as with mobile web app
    // as AmbitMobileLogin requires it

    let queryString:string = "";
    if ((PushType) || (functionName === "AmbitMobileLogin"))
    {
      queryString += "&PushType=" + PushType;
    }
    if ((PushUrl) || (functionName === "AmbitMobileLogin"))
    {
      queryString += "&PushUrl=" + this.DoEncodeComponent(PushUrl);
    }

    return queryString;
  }

  public GetLatestLocationQueryString(functionName:string):string
  {
    this._geoPosition = this.geolocationWrapperProvider.GetPosition();
    if (!this._geoPosition) return "";
    if (!this._geoPosition.Latitude) return "";

    if (functionName === this.apiName.SendMobileMonitorStatus)
    {
      this._geoPositionMonitor = this.geolocationWrapperProvider.GetPosition(); 
    }

    let queryString 
      = "&GpsProvidedFlag="           + "TRUE" // GpsProvidedFlag
      + "&GpsFormatCode="             + "DECIMAL" // GpsFormatCode
      + "&GpsLatitude="               + this.DoEncodeComponent(this._geoPosition.Latitude)       // "33.853200"
      + "&GpsLongitude="              + this.DoEncodeComponent(this._geoPosition.Longitude)     // "-117.836600"
      + this.GetDefinedQsValueNumber("GpsFloor", this._geoPosition.Floor)  // "1"
      + "&GpsAccuracyMeters="         + this.DoEncodeComponent(this._geoPosition.Accuracy) // "10"
      + "&PositionType="              + this.DoEncodeComponent(this._geoPosition.PositionType)
      + this.GetDefinedQsValueString("GpsAltitude", this._geoPosition.Altitude) 
      + "&GpsPositionChangedCounter=" + this._geoPosition.PositionCount
      + "&GpsMobileDatetime="         + this.DoEncodeComponent(this._geoPosition.MobileTimestamp)
      + "&GpsTimestamp="              + this.DoEncodeComponent(this._geoPosition.GpsTimestamp) // "2018-02-28T23:59:59:59"
      + "&GpsTimestampEpoch="         + this._geoPosition.Timestamp // 1549653371411
      //+ "&GpsAttemptHighAccuracy=" + GpsAttemptHighAccuracy
      //+ "&GpsAltitudeAccuracy=" + GpsAltitudeAccuracy
      //+ "&GpsHeading=" + GpsHeading
      //+ "&GpsSpeed=" + GpsSpeed
      ;
    
    return queryString;
  }

  GetDefinedQsValueNumber(qsName:string, qsValue:number):string
  {
    if (qsValue === null) 
    {
      return "";
    }

    return "&" + qsName + "=" + qsValue;
  }

  GetDefinedQsValueString(qsName:string, qsValue:string):string
  {
    if ((!qsValue) || (qsValue === null) || (qsValue === "null"))
    {
      return "";
    }

    return "&" + qsName + "=" + this.DoEncodeComponent(qsValue);
  }

  GetLastUsedGeoPositionMonitor():GeoPosition
  {
    return this._geoPositionMonitor;
  }
}
